<template>
  <div>
    <b-card no-body>
      <div class="card-smallHeader card-header-action" v-b-toggle.collapse-donnees-sinistre  :aria-expanded="(errors.date_du !== '' || errors.date_au !== '' || errors.montantIJSS !== '' || errors.montantIJSSNet !== '' || errors.dateReception !== '') ? 'true' : 'false'">
        <span><b>Données Sinistres</b></span> <i class="fa fa-exclamation text-danger ml-2" v-if="errors.date_du !== '' || errors.date_au !== '' || errors.montantIJSS !== '' || errors.dateReception !== ''"></i>
        <div class="card-header-actions">
              <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
          <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
        </div>
      </div>
      <b-collapse id="collapse-donnees-sinistre" class="m-3" visible :class="(errors.date_du !== '' || errors.date_au !== '' || errors.montantIJSS !== '' || errors.montantIJSSNet !== '' || errors.dateInfoDeces !== '' || errors.sourceInfo !== '') ? null : 'collapsed'">
        <b-row class="mb-2" v-if="(getTypeDossier() === 'ij' || getTypeDossier() === 'inval')">
          <b-col sm="6" style="margin-bottom:10px">
            <span><i>Date de fin de la dernière période payée : </i><b>{{ dateFinDernierePeriodePayee }}</b></span>
          </b-col>
          <b-col sm="6" style="margin-bottom:10px" v-if="getTypeDossier() === 'inval' && canSeeCaseReclamation()">
            <b-form-checkbox v-model="myData.nonEligibleClotureAuto" value="nonEligible" :disabled="isDisabled('nonEligibleClotureAuto')">
              Changement de situation / Demande de régul / Mécontentement
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="mb-2" v-if="getTypeDossier() === 'ij' || getTypeDossier() === 'inval'">
          <b-col sm="12" style="border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;">
            <b-row>
              <b-col sm="12" style="position: relative; top: -12px;">
                <span style="background-color: #FFFFFF; padding: 0 5px;"><b>Période sinistre : </b></span>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" md="6" xl="6">
                <b-form-group
                  label-for="dateDebutSinistre"
                  :label-cols="4"
                  :horizontal="true">
                  <template slot="label"><b>Date de début :</b></template>
                  <b-form-input v-if="myData.dateDebutIndisponible" type="text" class="custom-input-reduit disabled-input" placeholder="Donnée non disponible" disabled></b-form-input>
                  <b-form-input class="custom-input-reduit"
                                v-if="!myData.dateDebutIndisponible"
                                type="date"
                                :min="minDateDebutPsi"
                                id="dateDebutSinistre"
                                @paste="onPastePsi($event, 'debut')"
                                :disabled="isDisabled('dateDebutSinistre')"
                                v-model="myData.dateDebutSinistre"
                                :class="{hasError: errors.date_du !== ''}"
                                @blur="checkDate('debut')">
                  </b-form-input>
                  <b-form-checkbox class="custom-checkbox" @change="myData.dateDebutIndisponible = !myData.dateDebutIndisponible"></b-form-checkbox>
                  <i class="fa fa-question-circle" v-b-tooltip.hover title="Cochez cette case si vous n'avez pas l'information"></i>
                  <span class="field-error">{{ errors.date_du }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" xl="6">
                <b-form-group
                  label-for="dateFinSinistre"
                  :label-cols="4"
                  :horizontal="true">
                  <template slot="label"><b>Date de fin :</b></template>
                  <b-form-input type="date"
                                :max="maxDateFinPsi" id="dateFinSinistre" @paste="onPastePsi($event, 'fin')" :disabled="isDisabled('dateFinSinistre')"
                                v-model="myData.dateFinSinistre" :class="{hasError: errors.date_au !== ''}" @blur="checkDate('fin')">
                  </b-form-input>
                  <span class="field-error">{{ errors.date_au }}</span>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row v-if="getTypeDossier() === 'ij'">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="montantIJSS"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Montant IJSS :</b></template>
              <b-form-input id="montantIJSS" type="text" :disabled="isDisabled('montantIJSS')"
                            v-model="myData.montantIJSS" :class="{hasError: errors.montantIJSS !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.montantIJSS }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'ij' && (!isTypeDossierByLibelleTechnique('ij-bpij') || !isTypeDossierByLibelleTechnique('bpijo') || !isTypeDossierByLibelleTechnique('bpijp'))">
            <b-form-group
              label-for="montantIJSSNet"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>montant IJSS Net :</b></template>
              <b-form-input id="montantIJSSNet" type="text" :disabled="isDisabled('montantIJSSNet')"
                            v-model="myData.montantIJSSNet" :class="{hasError: errors.montantIJSSNet !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.montantIJSSNet }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'ij' && (!isTypeDossierByLibelleTechnique('ij-bpij') || !isTypeDossierByLibelleTechnique('bpijo') || !isTypeDossierByLibelleTechnique('bpijp'))">
            <b-form-group
              label-for="montantIJSSVariant"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Montant IJSS variant :</b></template>
              <b-form-checkbox
                        :disabled="isDisabled('hasMontantIJSSVariant')"
                        id="checkbox-hasMontantIJSSVariant"
                        v-model="myData.hasMontantIJSSVariant"
                        name="hasMontantIJSSVariant"
                        switch
                        >
                        {{ myData.hasMontantIJSSVariant ? 'Oui' : 'Non'}}
                      </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'ij' && (!isTypeDossierByLibelleTechnique('ij-bpij') || !isTypeDossierByLibelleTechnique('bpijo') || !isTypeDossierByLibelleTechnique('bpijp'))">
            <b-form-group
              label-for="credit"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Crédit :</b></template>
              <b-form-input id="credit" type="text" v-model="myData.credit" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6"  v-if="getTypeDossier() === 'ij'">
            <b-form-group
              label-for="causeSinistreId"
              :label-cols="4"
              :content-cols="8"
              :horizontal="true">
              <template slot="label"><b>Cause sinistre :</b></template>
              <b-form-select class="col-sm-5" v-model="myData.causeSinistreId"
                             :options="causeSinistreOptions"
                             :disabled="isDisabled('causeSinistreId')"
                             :class="{hasError: errors.causeSinistreId !== ''}">
              </b-form-select>
              <span class="col-sm-5">
                CODE NSI : {{ codeNsiCauseSinistre }}
              </span>
              <span class="field-error">{{ errors.causeSinistreId }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'ij'">
            <b-form-group
              label-for="precision_cause"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Précision Cause  :</b></template>
              <b-form-input id="precision_cause" type="text" v-model="myData.precision_cause" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row  v-if="getTypeDossier() === 'ij' && displayCauseTiers">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="IsCauseTiers"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Accident causé par un tiers :</b></template>
              <b-form-checkbox
                      :disabled="isDisabled('IsCauseTiers')"
                        id="checkbox-IsCauseTiers"
                        v-model="myData.IsCauseTiers"
                        name="IsCauseTiers"
                        switch
                        >
                        {{ myData.IsCauseTiers ? 'Oui' : 'Non'}}
                      </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'ij'">
            <b-form-group
                label-for="isS"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>En mi-temps thérapeutique :</b></template>
                <b-form-checkbox
                          :disabled="isDisabled('isSalarieEnMTT')"
                          id="checkbox-isSalarieEnMTT"
                          v-model="myData.isSalarieEnMTT"
                          name="isSalarieEnMTT"
                          switch
                          >
                          {{ myData.isSalarieEnMTT ? 'Oui' : 'Non'}}
                        </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'ij'">
            <b-form-group
                label-for="isS"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Sorti des effectifs :</b></template>
                <b-form-checkbox
                          :disabled="isDisabled('isSalarieSortiEffectif')"
                          id="checkbox-isSalarieSortiEffectif"
                          v-model="myData.isSalarieSortiEffectif"
                          name="isSalarieSortiEffectif"
                          switch
                          >
                          {{ myData.isSalarieSortiEffectif ? 'Oui' : 'Non'}}
                        </b-form-checkbox>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'ij'">
            <b-form-group
                label-for="isS"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Date reprise à temps complet :</b></template>
                <b-form-input type="date"
                                id="dateRepriseTemplsComplet" :disabled="isDisabled('dateRepriseTempsComplet')"
                                v-model="myData.dateRepriseTempsComplet" :class="{hasError: errors.dateRepriseTempsComplet !== ''}" @blur="checkDate('repriseTempsComplet')">
                  </b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'ij'">
            <b-form-group
                label-for="isS"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Date suspension de contrat :</b></template>
                <b-form-input type="date"
                                :min="maxDateFinPsi" id="dateSuspensionContrat" :disabled="isDisabled('dateSuspensionContrat')"
                                v-model="myData.dateSuspensionContrat" :class="{hasError: errors.dateSuspensionContrat !== ''}">
                  </b-form-input>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="getTypeDossier() === 'ij'">
          <b-col sm="12" md="6" xl="6">
            <b-form-group label-for="regle_cumul"
                  :label-cols="4"
                  :horizontal="true">
              <template slot="label"><b>Règle de cumul</b><i class="fa fa-question-circle ml-2 text-primary" id="tooltip-rc"></i></template>
              <b-tooltip target="tooltip-rc" triggers="hover">
                Règle de cumul détecté
              </b-tooltip>
              <b-form-select v-model="myData.selectedRegleCumul" :disabled="isDisabled('selectedRegleCumul')" :options="allRegleCumulOption">
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group label-for="flag"
                  :label-cols="4"
                  :horizontal="true">
              <template slot="label"><b>Flag non pec</b><i class="fa fa-question-circle ml-2 text-primary" id="tooltip-flag"></i></template>
              <b-tooltip target="tooltip-flag" triggers="hover">
                Motif de non prise en charge
              </b-tooltip>
              <b-form-select v-model="myData.selectedFlag" :disabled="isDisabled('selectedFlag')" :options="flagsOption">
                <template v-slot:first>
                  <b-form-select-option :value='null' disabled><strong>-- Choisir un flag --</strong></b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="(isTypeDossierByLibelleTechnique('ij-bpij') || isTypeDossierByLibelleTechnique('bpijo') || isTypeDossierByLibelleTechnique('bpijp'))">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="FluxSource"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Flux Source :</b></template>
              <b-form-input id="FluxSource" type="text" v-model="myData.fluxSource" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="FluxDossier"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Flux Dossier (ID) :</b></template>
              <b-form-input id="FluxDossier" type="text" v-model="myData.fluxDossier" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="(isTypeDossierByLibelleTechnique('ij-bpij') || isTypeDossierByLibelleTechnique('bpijo') || isTypeDossierByLibelleTechnique('bpijp'))">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="NbJrsIjPayes"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Nb de jours IJ payés  :</b></template>
              <b-form-input id="NbJrsIjPayes" type="text" v-model="myData.nbJrsIjPayes" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="EtatEvenement"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Etat évènement  :</b></template>
              <b-form-input id="EtatEvenement" type="text" v-model="myData.etatEvenement" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="getTypeDossier() === 'inval'">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="dateFaitGenerateur"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Date de fait générateur si identifié :</b></template>
              <b-form-input type="date" id="dateFaitGenerateur" @paste="onPaste($event, 'debut')" :disabled="isDisabled('dateFaitGenerateur')"
                            v-model="myData.dateFaitGenerateur" :class="{hasError: errors.date_du !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.date_du }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="datePam"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Lettre PAM envoyé le :</b></template>
              <b-form-input type="date" id="datePam" @paste="onPaste($event, 'fin')" :disabled="isDisabled('datePam')"
                            v-model="myData.datePam" :class="{hasError: errors.datePam !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.datePam }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="getTypeDossier() === 'inval'">
          <b-col sm="12" md="6" xl="6" v-if="getTypeInval() === 'inval'">
            <b-form-group
              label-for="categorieInval"
              :label-cols="4"
              :horizontal="true">
              <template slot="label" v-if="!isTypeDossierByLibelleTechnique('invcc')"><b>Catégorie : </b></template>
              <template slot="label" v-if="isTypeDossierByLibelleTechnique('invcc')"><b> Nouvelle Catégorie :</b></template>
              <b-form-radio-group id="categorieInval" v-model="myData.categorieInval" name="categorieInval" :class="{hasError: errors.categorieInval !== ''}" :disabled="isDisabled('categorieInval')">
                <b-form-radio value="CAT 1">CAT 1</b-form-radio>
                <b-form-radio value="CAT 2">CAT 2</b-form-radio>
                <b-form-radio value="CAT 3">CAT 3</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.categorieInval }}</span>
            </b-form-group>
            <b-form-group
              v-if="isTypeDossierByLibelleTechnique('invcc')"
              label-for="categorieInvalInitial"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b> Catégorie Initiale :</b></template>
              <b-form-radio-group id="categorieInvalInitial" class="mt-2" v-model="myData.categorieInvalInitial" name="categorieInvalInitial" :class="{hasError: errors.categorieInvalInitial !== ''}" :disabled="isDisabled('categorieInvalInitial')">
                <b-form-radio value="CAT 1">CAT 1</b-form-radio>
                <b-form-radio value="CAT 2">CAT 2</b-form-radio>
                <b-form-radio value="CAT 3">CAT 3</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.categorieInvalInitial }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6" v-else>
            <b-form-group
              label-for="taux"
              :label-cols="4"
              :horizontal="true">
              <template slot="label" v-if="!isTypeDossierByLibelleTechnique('incact')"><b>Taux : </b></template>
              <template slot="label" v-if="isTypeDossierByLibelleTechnique('incact')"><b> Nouveau Taux :</b></template>
              <b-input-group append="%" class="mb-2 mr-sm-2 mb-sm-0" id="taux">
                <b-form-input id="taux" type="number" step="0.01" v-model="myData.taux" :disabled="isDisabled('taux')">
                </b-form-input>
              </b-input-group>
              <span class="field-error">{{ errors.taux }}</span>
            </b-form-group>
            <b-form-group
              label-for="tauxInitial"
              :label-cols="4"
              :horizontal="true">
              <template slot="label" v-if="isTypeDossierByLibelleTechnique('incact')"><b> Taux Initial :</b></template>
              <b-input-group append="%" class="mb-2 mr-sm-2 mb-sm-0" id="tauxInitial">
                <b-form-input id="tauxInitial" type="number" step="0.01" v-model="myData.tauxInitial" :disabled="isDisabled('tauxInitial')">
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="dateEffet"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Date de mise en invalidité :</b></template>
              <b-form-input type="date" id="dateEffet" @paste="onPaste($event, 'fin')" :disabled="isDisabled('dateEffet')"
                            v-model="myData.dateEffet" :class="{hasError: errors.dateEffet !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dateEffet }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="getTypeDossier() === 'inval'">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="attestationRessource"
              :label-cols="4"
              :content-cols="8"
              :horizontal="true">
              <template slot="label"><b>Attestation de ressource :</b></template>
              <b-form-select class="col-sm-5" v-model="myData.attestationRessource"
                             :options="attestationRessourceOptions"
                             :disabled="isDisabled('attestationRessource')">
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="getTypeDossier() === 'dc'">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="dateInfoDeces"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Date information du décès :</b></template>
              <b-form-input type="date" id="dateInfoDeces" @paste="onPaste($event, 'debut')" :disabled="isDisabled('dateInfoDeces')"
                            v-model="myData.dateInfoDeces" :class="{hasError: errors.dateInfoDeces !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dateInfoDeces }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="sourceInfo"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Source information :</b></template>
              <b-form-select v-model="myData.sourceInfo"
                             :disabled="isDisabled('sourceInfo')">
                <b-form-select-option value=""><i>Choisissez la source de l'information</i></b-form-select-option>
                <b-form-select-option value="agira_o">AGIRA Obsèques</b-form-select-option>
                <b-form-select-option value="agira_1">AGIRA 1 (Ex 2005)</b-form-select-option>
                <b-form-select-option value="agira_2">AGIRA 2 (Ex 2007)</b-form-select-option>
                <b-form-select-option value="employeur">Employeur</b-form-select-option>
                <b-form-select-option value="beneficiaire">Bénéficiaire(s)</b-form-select-option>
                <b-form-select-option value="famille">Membre de la famille</b-form-select-option>
                <b-form-select-option value="notaire">Notaire</b-form-select-option>
                <b-form-select-option value="autre">Autre</b-form-select-option>
              </b-form-select>
              <span class="field-error">{{ errors.sourceInfo }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="getTypeDossier() === 'dc'">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="dateDeces"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Date du décès :</b></template>
              <b-form-input type="date" id="dateDeces" @paste="onPaste($event, 'debut')" :disabled="isDisabled('dateDeces')"
                            v-model="myData.dateDeces" :class="{hasError: errors.dateDeces !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dateDeces }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="typeDeces"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Type de contrat :</b></template>
              <b-form-radio-group id="typeDeces" v-model="myData.typeDeces" name="typeDeces" :class="{hasError: errors.typeDeces !== ''}" :disabled="isDisabled('typeDeces')">
                <b-form-radio value="collectif">Décès collectif</b-form-radio>
                <b-form-radio value="individuel">Décès individuel</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.typeDeces }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="date_reception"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Date de réception :</b></template>
              <b-form-input id="date_reception" :disabled="isDisabled('dateReception')" type="date"
                            :class="{hasError: errors.dateReception !== ''}"
                            v-model="myData.dateReception">
              </b-form-input>
              <span class="field-error">{{ errors.dateReception }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="canal"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Canal de réception :</b></template>
              <b-form-select v-model="myData.selectedCanal"
                             :options="canalOptions"
                             disabled>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label-for="dateReceptionCourrier"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Date réception réelle :</b></template>
              <b-form-input
                type="date"
                id="dateReceptionCourrier"
                :disabled="isDisabled('dateReceptionCourrier')"
                v-model="myData.dateReceptionCourrier"
                :class="{hasError: errors.dateReceptionCourrier !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dateReceptionCourrier }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="6" v-if="getTypeDossier() === 'dc' && !isEmpty(relancesItems)">
            <b-card class="data-relances">
              <b-row>
                <b-col sm="4"><b>Date de relance</b></b-col>
                <b-col sm="4"><b>Type de relance</b></b-col>
                <b-col sm="4"><b>Destinataire / Bénéficiaire</b></b-col>
              </b-row>
              <b-row v-for="(relance, key) in relancesItems" :key="key">
                <b-col sm="4">
                  <span>{{ formatDateSynthese(relance.date_relance) }}</span>
                </b-col>
                <b-col sm="4">
                  <span>{{ relance.type}}</span>
                </b-col>
                <b-col sm="4">{{ relance.destinataire }}</b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="getTypeDossier() === 'inval' || getTypeDossier() === 'dc'">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="dossierIdFaitGenerateur"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>N° dossier (fait générateur)  :</b></template>
              <b-form-input id="dossierIdFaitGenerateur" type="number" v-model="myData.dossierIdFaitGenerateur" :disabled="isDisabled('dossierIdFaitGenerateur')">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group label-for="flag"
                  :label-cols="4"
                  :horizontal="true">
              <template slot="label"><b>Flag</b><i class="fa fa-question-circle ml-2 text-primary" id="tooltip-flag"></i></template>
              <b-tooltip target="tooltip-flag" triggers="hover">
                Motif de non prise en charge
              </b-tooltip>
              <b-form-select v-model="myData.selectedFlag" :disabled="isDisabled('selectedFlag')" :options="flagsOption">
                <template v-slot:first>
                  <b-form-select-option :value='null' disabled><strong>-- Choisir un flag --</strong></b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'ij'">
            <b-form-group
              label-for="numPsi"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>N° PSi :</b></template>
              <b-form-input id="numPsi" type="number" min="0" v-model="myData.numPsi" :disabled="isDisabled('numPsi')">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="rar"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>RAR :</b></template>
              <b-form-input id="rar" type="text" v-model="myData.rar" :disabled="isDisabled('rar')">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6" v-if="getTypeDossier() === 'dc'">
            <b-form-group
              label-for="dateCourrierInitialisation"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Date mail/courrier initialisation :</b></template>
              <b-form-input
                type="date"
                id="dateCourrierInitialisation"
                :disabled="isDisabled('dateCourrierInitialisation')"
                v-model="myData.dateCourrierInitialisation"
                :class="{hasError: errors.dateCourrierInitialisation !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dateCourrierInitialisation }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="emetteur"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Emetteur :</b></template>
              <b-form-input id="emetteur" type="text" v-model="myData.emetteur" :disabled="isDisabled('emetteur')">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="numArchives2"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>N° d'archives :</b></template>
              <b-form-input id="numArchives2" :disabled="isDisabled('numArchives')"
                            type="text" v-model="myData.numArchives">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="numeroEvenementNsi"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>N° Evenement NSI :</b></template>
              <b-form-input id="numeroEvenementNsi" :disabled="isDisabled('numeroEvenementNsi')"
                            type="text" v-model="myData.numeroEvenementNsi">
              </b-form-input>
            </b-form-group>
          </b-col>
          </b-row>
        <b-row v-if="(isTypeDossierByLibelleTechnique('ij-bpij') || isTypeDossierByLibelleTechnique('bpijo') || isTypeDossierByLibelleTechnique('bpijp'))">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="FluxSource"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Flux Source :</b></template>
              <b-form-input id="FluxSource" type="text" v-model="myData.fluxSource" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="FluxDossier"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Flux Dossier (ID) :</b></template>
              <b-form-input id="FluxDossier" type="text" v-model="myData.fluxDossier" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="(isTypeDossierByLibelleTechnique('ij-bpij') || isTypeDossierByLibelleTechnique('bpijo') || isTypeDossierByLibelleTechnique('bpijp'))">
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="NbJrsIjPayes"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Nb de jours IJ payés  :</b></template>
              <b-form-input id="NbJrsIjPayes" type="text" v-model="myData.nbJrsIjPayes" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="EtatEvenement"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Etat évènement  :</b></template>
              <b-form-input id="EtatEvenement" type="text" v-model="myData.etatEvenement" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="expediteur"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Expéditeur :</b></template>
              <b-form-input id="expediteur" v-model="myData.expediteur" type="text" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="expediteur"
              :horizontal="true"
              class="pt-1 pb-1">
              <fieldset :hidden="cantEditFicheDC(dossier)">
                <i v-if="canShowCreate()" @click="initiateMail('create')" class="fa fa-envelope-square fa-2x text-primary clickable align-middle mr-4" title="Envoyer un mail au client (Attention ce n'est pas une DPC)"></i>
                <i v-else @click="initiateMail('continue')" class="fa fa-envelope-open fa-2x text-primary clickable align-middle mr-1" title="Continuer le mail à envoyer au client (Attention ce n'est pas une DPC)"></i>
                <i v-if="!canShowCreate()" @click="deleteMail()" class="fa fa-trash text-danger clickable align-middle mr-3" title="Supprimer le mail initié"></i>
                <i v-if="canShowSentMail()" @click="showSentMail()" class="fa fa-envelope align-middle clickable" title="Voir les mails déjà envoyés au client"></i>
                <span v-if="getTypeDossier() === 'dc'" class="mr-2" style="margin-left:20px"><span style="color: #ffa434"><b-button size="sm" variant="success" type="button" @click="initiateMailMutex()" title="Envoyer les pièces relatives au dossier à Mutex">Envoi Mutex</b-button> </span></span>
                <i v-if="getTypeDossier() === 'dc' && canShowSentMailMutex()" @click="showSentMailMutex()" class="fa fa-envelope align-middle clickable" title="Voir les mails déjà envoyés à Mutex"></i>
                <i v-if="canShowForward()" @click="showForward = !showForward" class="fa fa-share-square fa-2x text-warning clickable align-middle mr-4" title="transferer le mail à la relation client"></i>
              </fieldset>
              <div class="d-inline-block w-auto" v-if="showForward">
                <div class="row">
                  <div class="col-md-12">
                    <b-form-select v-if="showForward" v-model="selectedBal" :options="balsForwardOption" size="sm" class="mt-1 mb-1 col-md-6" :class="{hasError: errors.selectedBal !== ''}"></b-form-select>
                    <button v-if="showForward" type="button" class="btn btn-warning ml-2 btn-sm" @click="forwardMail()">Transférer</button>
                  </div>
                  <div class="col-md-12">
                    <b-form-textarea
                      name="textareaCommentaire"
                      v-model="commentaireForward"
                      placeholder="Commentaire"
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </div>
              </div>
              <span class="field-error">{{ errors.selectedBal }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6">
            <b-form-group
              label-for="fiche_tel"
              :label-cols="4"
              :horizontal="true">
              <template slot="label"><b>Fiche Niv.2 :</b></template>
              <div v-if="ficheNiv2Prestations !== 0" style="margin-top:8px">
                <b-link class="btn btn-primary" v-if="!loadingFiche" :href="getSrc()" target="_BLANK">{{ ficheNiv2Prestations }} fiches</b-link>
                <loading-field v-if="loadingFiche" />
              </div>
              <div v-else style="margin-top:8px">
                <label>{{ ficheNiv2Prestations }} fiches</label>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6" xl="6">
            <div>
              <span v-b-tooltip.hover.righttop="{ customClass: 'pre-formatted' }"
                    :title="getTooltip()"
                    :id="'tooltip-note-'+dossier.id">
                <img class="clickable" :src="getIconSrc('post-it', dossier)" @click="editCommentaire(dossier)"/>
              </span>
            </div>
          </b-col>
          <b-col sm="12" md="6" xl="6" v-if="getTypeDossier() === 'dc' && !isEmpty(dossier.fiche_deces)">
            <b-button variant="warning" @click="showSynthese()">Afficher synthèse complétude</b-button>
            <b-button class="ml-2" variant="primary" @click="showSynthese('assure')">Afficher synthèse Assuré</b-button>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <b-modal size="xl" scrollable id="modal-commentaire" ref="modal-commentaire" title="Commentaires sur le dossier">
      <b-row v-for="(commentaire,key) of commentairesGestion" class="align-items-center" :key="commentaire.id">
        <b-col md="10" style="display: inline-block;">
          <label>Commentaire
            <span class="smaller-2">
              <i>Dernière modification le {{ formatDateHeure(commentaire.updated_at) }}
                par <span v-if="commentaire.gestionnaire != null">{{ commentaire.gestionnaire.prenom }} {{ commentaire.gestionnaire.nom }}</span>
                <span v-else> Système</span>
              </i>
            </span>
          </label>
          <b-form-textarea
            :id="'commentaire-'+commentaire.id"
            v-model="commentaires[commentaire.id].texte"
            placeholder="Saisir un commentaire..."
            rows="3"
            max-rows="6"
            :class="{hasError: errors.commentaire !== '' && commentaires[commentaire.id].texte === ''}">
          </b-form-textarea>
        </b-col>
        <b-col md="2" class="align-middle">
          <b-form-checkbox v-model="commentaires[commentaire.id].is_urgent" name="check-button"
                           switch> Urgent
          </b-form-checkbox>
          <b-form-checkbox v-model="commentaires[commentaire.id].is_relation_client" name="check-button"
                           switch> Relation Client
          </b-form-checkbox>
          <i class="fa fa-trash fa-1_5x mt-1 text-danger clickable" v-if="canDeleteCommentaire(commentaire)" v-b-tooltip.hover title="Supprimer le commentaire"
          @click="deleteCommentaire(commentaire)"></i>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <button v-if="addComHidden" type="button" title="Ajouter un commentaire"
                  class="btn btn-succes mr-1  pull-right" @click="addComHidden = false"><i
            class="fa fa-plus-circle fa-2x text-success" aria-hidden="true"></i></button>
        </b-col>
      </b-row>
      <b-row v-if="!addComHidden">
        <b-col md="10">
          <b-card no-body class="mt-3">
            <div class="card-smallHeader">
              <i class="fa fa-justify mr-2"></i>
              <strong>Ajouter un commentaire</strong>
            </div>
            <b-card-body>
              <b-form-group>
                <b-form-textarea
                  v-model="commentaireToAdd"
                  placeholder="Saisir un commentaire..."
                  rows="3"
                  max-rows="6"
                  :class="{hasError: errors.commentaire !== '' && commentaireToAdd === '' && (isUrgentToAdd === true || isRelationClientToAdd === true)}"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group class="align-middle">
                <b-form-checkbox v-model="isUrgentToAdd" name="check-button" switch> Urgent</b-form-checkbox>
              </b-form-group>
              <b-form-group class="align-middle">
                <b-form-checkbox v-model="isRelationClientToAdd" name="check-button" switch> Relation Client</b-form-checkbox>
              </b-form-group>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <span class="field-error inline mr-1 float-right">{{ errors.commentaire }}</span>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal()">Annuler</button>
          <button type="button" @click="saveCommentaire()" class="btn btn-primary"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close title="Envoi d'un mail au client" id="modal-mail-to-client" ref="modal-mail-to-client">
      <b-form>
        <b-row>
          <b-col sm="1">
            <label for="reponseTo">A :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="reponseTo" type="text" v-model="reponseTo" :class="{hasError: errors.reponseTo !== ''}"></b-form-input>
            <span class="field-error">{{ errors.reponseTo }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="reponseCc">Cc :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="reponseCc" type="text" v-model="reponseCc"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="reponseSubject">Objet :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="reponseSubject" type="text" v-model="reponseSubject" :class="{hasError: errors.reponseSubject !== ''}"></b-form-input>
            <span class="field-error">{{ errors.reponseSubject }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm=8>
            <ul class="no-padding no-decoration">
              <li v-for="(pj, key) in mailAttachmentsUploaded" :key="key">
                <a href="#" @click.prevent="downloadMailPj(pj)"><img class="mr-2 icon-size-16" :src="getIconPjSrc(pj)"> {{ pj.name }}</a> {{getReadableFileSize(pj.size)}} <i @click="deleteMailPj(pj)" class="fa fa-trash text-danger clickable"></i>
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col sm="6">
            <b-row align-h="start" class="mt-2">
              <b-col sm="2">
                <label for="files">Fichier(s) :</label>
              </b-col>
              <b-col sm="8">
                <b-form-file placeholder="Veuillez choisir ou déposer le(s) fichier(s) ici"
                  multiple
                  class="file-input"
                  drop-placeholder="Déposer le(s) fichier(s) ici..."
                  browse-text="Parcourir"
                  :file-name-formatter="formatNames"
                  @change="addFileToMail($event)"
                >
                </b-form-file>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr>
        <b-row class="pre-formatted">
          <ckeditor :editor="editor" v-model="reponseBody" :config="editorConfig"  :class="{hasError: errors.reponseBody !== ''}"></ckeditor>
          <span class="field-error">{{ errors.reponseBody }}</span>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100" v-if="!cantEditFicheDC(dossier)">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="sendReponse('send')">
            <i class="fa fa-paper-plane"></i>
            Envoyer
          </b-button>
          <b-button
            variant="warning"
            class="float-right ml-2"
            @click="sendReponse('save')">
            <i class="fa fa-save"></i>
            Brouillon
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="$bvModal.hide('modal-mail-to-client')">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal scrollable size="xl" id="modal-mails-envoye" ref="modal-mails-envoye" title="Mails envoyé au client" ok-only ok-title="Fermer">
      <b-card v-for="mail in mails" :key="mail.id">
        <b-card class="block-mail">
          <b-list-group flush>
            <b-list-group-item>
              <b-row>
                <b-col sm="12" class="borded-right">
                  <b-card-text>
                    <b-row :class="`mb-2`">
                      <b-col sm="2">
                        De :
                      </b-col>
                      <b-col sm="9">
                        {{ mail.mail_from }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12" class="borded-right">
                  <b-card-text>
                    <b-row :class="`mb-2`">
                      <b-col sm="2">
                        A :
                      </b-col>
                      <b-col sm="9">
                        {{ mail.mail_to }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12" class="borded-right">
                  <b-card-text>
                    <b-row :class="`mb-2`">
                      <b-col sm="2">
                        Copie :
                      </b-col>
                      <b-col sm="9">
                        {{ mail.mail_cc }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12">
                  <b-row>
                    <b-col sm="2">
                      Pièce(s) jointe(s) :
                    </b-col>
                    <b-col sm="9">
                      <b-row v-for="pj in mail.pieces_jointes" :key="pj.id">
                        <b-col sm="12">
                          {{ pj.name }}
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12">
                  <b-row>
                    <b-col sm="2">
                      Objet :
                    </b-col>
                    <b-col sm="9">
                      {{ mail.subject }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12">
                  <b-row>
                    <b-col sm="2">
                      Envoyé le :
                    </b-col>
                    <b-col sm="9">
                      {{ formatDateHeure(mail.sent_at) }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col class="nopadding" sm="12">
                  <b-card-text v-html="mail.body">
                  </b-card-text>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-card>
    </b-modal>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :paginate-elements-by-height="1400"
      filename="Décès-synthèse-assuré"
      :pdf-quality="4"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2PdfAssure"
    >
      <!-- <section slot="pdf-content"> -->
        <synthese-assure v-if="getTypeDossier() === 'dc'" :dossier="dossier" :dcFamilleProduitPdf="dcFamilleProduitPdf" slot="pdf-content"></synthese-assure>
      <!-- </section> -->
    </vue-html2pdf>

    <b-modal v-if="!isEmpty(dossier.fiche_deces)" size="xl" id="modal-synthese-assure" ref="modal-synthese-assure" title="Synthèse assuré·e" ok-only ok-title="Fermer">
      <h5>Assuré : {{ dossier.prenom }} {{ dossier.nom }}</h5>
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">1</b-badge> <b>Identification assuré</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">N° SS</b> : <span class="ml-3">{{ dossier.nir }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Date du décès</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_deces) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Cause décès</b> : <span class="ml-3" v-if="dossier.fiche_deces.cause_deces === 'mort_naturelle'">Mort naturelle</span><span class="ml-3" v-if="!isEmpty(dossier.fiche_deces.cause_deces) && dossier.fiche_deces.cause_deces !== 'mort_naturelle'">{{ dossier.fiche_deces.cause_deces[0].toUpperCase() + dossier.fiche_deces.cause_deces.substring(1) }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">2</b-badge> <b>Couverture prévoyance</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-12">L'assuré remplit-il les conditions pour bénéficier du contrat de prévoyance ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.is_elligible_contrat_prevoyance === true ? 'Oui' : (dossier.fiche_deces.is_elligible_contrat_prevoyance === false ? 'Non' : '') }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-12">L'assuré bénéficiait-il de la portabilité ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.has_portabilite ? 'Oui' : (dossier.fiche_deces.has_portabilite === false ? 'Non' : '') }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-12">L'assuré était-il en suspension du contrat de travail ou bénéficiait-il d'un accord sénior ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.suspention_contrat === 'tp' ? 'Oui à temps partiel' : (dossier.fiche_deces.suspention_contrat === 'tc' ? 'Oui à temps complet' : (dossier.fiche_deces.suspention_contrat === 'non' ? 'Non' : '')) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-12">Avait-il souscrit à l'option maintien des garanties décès ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.has_option_maintien_garantie ? 'Oui' : (dossier.fiche_deces.has_option_maintien_garantie === false ? 'Non' : '') }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">3</b-badge> <b>Situation de l'assuré au Décès</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">L'assuré était-il toujours salarié ?</b> <span class="ml-2">{{ dossier.fiche_deces.was_salarie === true ? 'Oui' : (dossier.fiche_deces.was_salarie === false ? 'Non' : '') }}</span>
              </div>
              <div v-if="dossier.fiche_deces.was_salarie === false">
                <b class="d-inline-block col-sm-6">Si non, indiquer la date de RUPC</b> <span class="ml-2">{{ formatDateSynthese(dossier.fiche_deces.date_rupc) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">L'assuré avait-il un dossier en cours à la date du décès ?</b> <span class=" ml-2">{{ dossier.fiche_deces.had_dossier_en_cours === true ? 'Oui' : (dossier.fiche_deces.had_dossier_en_cours === false ? 'Non' : '') }}</span>
              </div>
              <div v-if="dossier.fiche_deces.had_dossier_en_cours === true">
                <b class="d-inline-block col-sm-6">Si oui, préciser </b> : <span class="ml-2">{{ dossier.fiche_deces.type_dossier_en_cours === 'ij' ? 'IJ' : (dossier.fiche_deces.type_dossier_en_cours === 'inval-1-2' ? 'Inval 1ère / 2ème' : (dossier.fiche_deces.type_dossier_en_cours === 'inval-3' ? 'Inval 3ème' : '')) }}</span>
              </div>
              <div v-if="dossier.fiche_deces.had_dossier_en_cours === true">
                <b class="d-inline-block col-sm-6">Date fait générateur</b> : <span class="ml-2">{{ formatDateFinPeriode(dossier.fiche_deces.date_fait_generateur) }}</span>
              </div>
              <div v-if="dossier.fiche_deces.had_dossier_en_cours === true">
                <b class="d-inline-block col-sm-6">Dernier jour payé</b> : <span class="ml-2">{{ formatDateFinPeriode(dossier.fiche_deces.date_dernier_jour_paye) }}</span>
              </div>
              <div v-if="dossier.fiche_deces.type_dossier_en_cours === 'inval-3'">
                <b class="d-inline-block col-sm-6">Si inval. 3ème catégorie, le capital IAD a-t-il été versé ?</b> : <span class="ml-2">{{ dossier.fiche_deces.has_capital_iad_verse === true ? 'Oui' : (dossier.fiche_deces.has_capital_iad_verse === false ? 'Non' : '') }}</span> <b v-if="dossier.fiche_deces.has_capital_iad_verse === true" class="text-danger">REFUS</b>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">4</b-badge> <b>Mise à jour NSI</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-12">Le dossier est-il à jour des règlements ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.is_reglement_a_jour === true ? 'Oui' : (dossier.fiche_deces.is_reglement_a_jour === false ? 'Non' : '') }}</span>
              </div>
              <div v-if="dossier.fiche_deces.is_reglement_a_jour === false">
                <b class="d-inline-block col-sm-12">Si non, préciser :</b>
                <span class="col-sm-12 ml-2">{{
                  dossier.fiche_deces.precision_non_a_jour === 'complement_notaire' ? 'Paiement complémentaire à faire au notaire' : (
                  dossier.fiche_deces.precision_non_a_jour === 'complement_employeur' ? 'Paiement complémentaire à faire à l\'employeur' : (
                  dossier.fiche_deces.precision_non_a_jour === 'indu_notaire' ? 'Indu à réclamer au notaire' : (
                  dossier.fiche_deces.precision_non_a_jour === 'indu_employeur' ? 'Indu à réclamer à l\'employeur' : ''))) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-12">La date du fait générateur est-elle à enregistrer dans NSI ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.is_fait_generateur_a_enregistrer_nsi === true ? 'Oui' : (dossier.fiche_deces.is_fait_generateur_a_enregistrer_nsi === false ? 'Non' : '') }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Numéro évènement décès NSI</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_evenement_nsi }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">5</b-badge> <b>Concernant les bénéficiaires du capital</b></span>
            </div>
            <b-card-text class="d-inline-block p-1 col-sm-6">
              <div>
                <b class="d-inline-block col-sm-6">Numéro de SIRET</b> : <span class="ml-2">{{ dossier.siren }} {{ dossier.nic }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Base</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_contrat_base }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_contrat_base) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Option</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_contrat_option }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_contrat_option) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Option 2</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_contrat_option2 }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_contrat_option2) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Statut de l'assuré</b> : <span class="ml-2">{{
                  dossier.fiche_deces.statut_assure === 'cadre' ? 'Cadre' : (
                  dossier.fiche_deces.statut_assure === 'non_cadre' ? 'Non cadre' : (
                  dossier.fiche_deces.statut_assure === 'th' ? 'TH' : '')) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Bénéficiait-il d'un contrat TB Médéric ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.has_tb_mederic === true ? 'Oui' : (dossier.fiche_deces.has_tb_mederic === false ? 'Non' : '') }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Avait-il plusieurs employeurs ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.is_multi_siren === true ? 'Oui' : (dossier.fiche_deces.is_multi_siren === false ? 'Non' : '') }}</span>
              </div>
            </b-card-text>
            <b-card class="d-inline-block card-employeur-synthese col-sm-6" v-for="(employeur,id) in dossier.deces_employeur" :key="id">
              <div>
                <b class="d-inline-block col-sm-6">Numéro de SIRET</b> : <span class="ml-2">{{ employeur.siren }} {{ employeur.nic }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Base</b> : <span class="ml-2">{{ employeur.numero_contrat_base }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(employeur.famille_produit_id_base) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Option</b> : <span class="ml-2">{{ employeur.numero_contrat_option }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(employeur.famille_produit_id_option) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Statut de l'assuré</b> : <span class="ml-2">{{
                  employeur.statut_assure === 'cadre' ? 'Cadre' : (
                  employeur.statut_assure === 'non_cadre' ? 'Non cadre' : (
                  employeur.statut_assure === 'th' ? 'TH' : '')) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Bénéficiait-il d'un contrat TB Médéric ?</b> : <span class=" ml-2">{{ employeur.has_tb_mederic === true ? 'Oui' : (employeur.has_tb_mederic === false ? 'Non' : '') }}</span>
              </div>
            </b-card>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">6</b-badge> <b>Vérification exclusions</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-12">Les clauses d'exclusion prévues par le contrat sont-elles avérées ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.is_clauses_exclusion_averees === true ? 'Oui' : (dossier.fiche_deces.is_clauses_exclusion_averees === false ? 'Non' : '') }}</span>
              </div>
              <span v-if="dossier.fiche_deces.is_clauses_exclusion_averees === true" class="text-danger font-weight-bold" style="font-size: 1.3em;">{{ refus }}</span>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">7</b-badge> <b>Vérification REC</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">Le contrat est-il résilié ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.is_contrat_resilie === true ? 'Oui' : (dossier.fiche_deces.is_contrat_resilie === false ? 'Non' : '') }}</span>
              </div>
              <div v-if="dossier.fiche_deces.is_contrat_resilie === true">
                <div>
                  <b class="d-inline-block col-sm-6">Si oui, préciser le motif </b> :
                  <span class="ml-2">{{
                    dossier.fiche_deces.motif_resiliation === 'fusion' ? 'Fusion/Absorption' : (
                    dossier.fiche_deces.motif_resiliation === 'demande_souscripteur' ? 'Demande contractuelle du souscripteur' : (
                    dossier.fiche_deces.motif_resiliation === 'regroupement' ? 'Regroupement de gestion' : (
                    dossier.fiche_deces.motif_resiliation === 'autre' ? 'Autre :' : ''))) }}</span>
                  <span v-if="dossier.fiche_deces.motif_resiliation === 'autre'" class="ml-2">( {{dossier.fiche_deces.motif_resiliation_autre}} )</span>
                </div>
                <div>
                  <b class="d-inline-block col-sm-6">La fermeture a-t-elle été effectuée à niveau atteint ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.is_fermeture_effectuee_niveau_atteint === true ? 'Oui' : (dossier.fiche_deces.is_fermeture_effectuee_niveau_atteint === false ? 'Non' : '') }}</span>
                </div>
                <div v-if="dossier.fiche_deces.is_fermeture_effectuee_niveau_atteint === true">
                  <div>
                    <b class="d-inline-block col-sm-6">Si oui, MEP nouveau contrat ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.is_mep_nouveau_contrat === true ? 'Oui' : (dossier.fiche_deces.is_mep_nouveau_contrat === false ? 'Non' : '') }}</span>
                  </div>
                  <div v-if="dossier.fiche_deces.is_mep_nouveau_contrat === true">
                    <div>
                      <b class="d-inline-block col-sm-6">Numéro de SIRET</b> : <span class="ml-2">{{ dossier.fiche_deces.siren_nouveau_contrat }} {{ dossier.fiche_deces.nic_nouveau_contrat }}</span>
                    </div>
                    <div>
                      <b class="d-inline-block col-sm-6">N° contrat Base</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_nouveau_contrat_base }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_nouveau_contrat_base) }}</i></span>
                    </div>
                    <div>
                      <b class="d-inline-block col-sm-6">N° contrat Option</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_nouveau_contrat_option }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_nouveau_contrat_option) }}</i></span>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="danger" class="float-right ml-2" @click="closeModal">Fermer</b-button>
          <b-button variant="primary" class="float-right ml-2" @click="generatePdfAssure()"> Export PDF</b-button>
        </div>
      </template>
    </b-modal>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :paginate-elements-by-height="1100"
      filename="Décès-synthèse-complétude"
      :pdf-quality="4"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
    >
      <!-- <section slot="pdf-content"> -->
      <synthese-completude v-if="getTypeDossier() === 'dc'" :dossier="dossier" :rentesOptions="rentesOptions" :capitalOptions="capitalOptions" :allocationsOptions="allocationsOptions" slot="pdf-content"></synthese-completude>
      <!-- </section> -->
    </vue-html2pdf>

    <b-modal v-if="!isEmpty(dossier.fiche_deces)" size="xl" id="modal-synthese" ref="modal-synthese" title="Complétude du dossier décès" ok-only ok-title="Fermer">
      <h5>Assuré : {{ dossier.prenom }} {{ dossier.nom }}</h5>
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">1</b-badge> <b>Information décès</b></span>
            </div>
            <b-card-text class="p-1">
              <b-row>
                <b-col sm="6"><b class="d-inline-block col-sm-6">Date information décès</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_information_deces) }}</span></b-col>
                <b-col sm="6"><b class="d-inline-block col-sm-8">Date envoi mail/courrier d'initialisation</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_courrier_initialisation) }}</span></b-col>
              </b-row>
              <b-row>
                <b-col sm="6"><b class="d-inline-block col-sm-6">Origine information décès</b> : <span v-if="!isEmpty(dossier.fiche_deces.source_information)" class="ml-3">{{ dossier.fiche_deces.source_information.toUpperCase() }}</span></b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">2</b-badge> <b>Identification du/des bénéficiaire(s)</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">Situation familliale</b> : <span v-if="!isEmpty(dossier.fiche_deces.situation_familiale)" class="ml-3">{{ dossier.fiche_deces.situation_familiale.libelle }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Désignation de bénéficiaires</b> : <span v-if="!isEmpty(dossier.fiche_deces.type_db)" class="ml-3">{{ dossier.fiche_deces.type_db[0].toUpperCase() + dossier.fiche_deces.type_db.substring(1) }}</span> <span class="ml-1" v-if="dossier.fiche_deces.type_db === 'autre'">( {{ dossier.fiche_deces.type_db_autre }} )</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Cause décès</b> : <span class="ml-3" v-if="dossier.fiche_deces.cause_deces === 'mort_naturelle'">Mort naturelle</span><span class="ml-3" v-if="!isEmpty(dossier.fiche_deces.cause_deces) && dossier.fiche_deces.cause_deces !== 'mort_naturelle'">{{ dossier.fiche_deces.cause_deces[0].toUpperCase() + dossier.fiche_deces.cause_deces.substring(1) }}</span>
              </div>
              <div v-if="dossier.fiche_deces.cause_deces === 'suicide'">
                <b style="padding-left: 15px;">Si suicide, l'assuré remplit-il les conditions d'ancienneté prévues ?</b> : <span class="ml-3">{{ dossier.fiche_deces.has_condition_ancienete === true ? 'Oui' : 'Non' }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">3</b-badge> <b>Garanties souscrites</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-checkbox v-model="dossier.fiche_deces.has_capital_deces" name="checkbox-has_capital_deces" disabled>
                Capital décès
              </b-form-checkbox>
              <b-form-checkbox class="ml-4" v-model="dossier.fiche_deces.has_majoration_accident" disabled>
                Majoration accident
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_capital_optionnel" disabled>
                Capital optionnel
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_majorations_familiales" disabled>
                Majorations familiales
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_rente_conjoint_ocirp" disabled>
                Rente conjoint (viagère / temporaire) OCIRP
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_rente_conjoint_chorum" disabled>
                Rente conjoint (viagère / temporaire) Chorum
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_rente_substitutive_conjoint" disabled>
                Rente substitutive de conjoint (OCIRP)
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_frais_obseques" disabled>
                Frais d'obsèques
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_capital_deces_famille" disabled>
                Capital décès famille
              </b-form-checkbox><br>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">4</b-badge> <b>Concernant l'assuré</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">Déclaration de décès</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_declaration_deces) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Acte de décès</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_acte_deces) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Certificat médical post-mortem</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_certificat_post_mortem) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">PV de la gendarmerie</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_pv_gendarmerie) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Dernier avis d'imposition</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_dernier_avis_imposition) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Attestation période activité</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_attestation_periode_activite) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Photocopie 12 BS</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_photocopie_12_bs) }}</span>
              </div>
              <div class="pl-3">
                <span class="mr-2"><b>Période du</b></span>{{ formatDateSynthese(dossier.fiche_deces.date_bs_periode_du) }}<span class="ml-2 mr-2"> <b>au</b> </span>{{ formatDateSynthese(dossier.fiche_deces.date_bs_periode_au) }}
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">5</b-badge> <b>Concernant la situation familiale</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">Livret de famille</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_livret_famille) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Acte de notoriété mention PACS</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_acte_notoriete_mention_pacs) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Extrait acte de naissance (assuré)</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_extrait_acte_naissance) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Attestation Tribunal Instance PACS</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_attestation_tribunal_instance_pacs) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Attestation PACS non dénoncé</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_attestation_pacs_non_denonce) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Attestation de concubinage</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_attestation_concubinage) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Justificatif de domicile commun</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_justificatif_domicile_commun) }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">6</b-badge> <b>Concernant les bénéficiaires du capital</b></span>
            </div>
            <b-card-text class="p-1">
              <b-row class="mb-2">
                <b-col sm="2"><b>Nom</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="beneficiaire.id" >
                  <b>{{ beneficiaire.prenom+' '+beneficiaire.nom }}</b><br>
                  <span class="smaller" v-html="getCapitalDecesLibelle(beneficiaire)"></span><br>
                  <span class="smaller" v-html="getAllocationsLibelle(beneficiaire)"></span>
                </b-col>
              </b-row>
              <b-row class="synthese-even">
                <b-col sm="2"><b>RIB</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'rib'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_rib) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd">
                <b-col sm="2"><b>Justificatif de domicile</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jd'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_justificatif_domicile) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even">
                <b-col sm="2"><b>Pièce d'identité</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'pi'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_piece_identite) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd">
                <b-col sm="2"><b>Jugement de tutelle</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jt'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_jugement_tutelle) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even">
                <b-col sm="2"><b class="text-danger">Date connaissance adresse bénéficiaire</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_connaissance_adresse_beneficiaire) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd">
                <b-col sm="2"><b>Facture acquittée des frais d'obsèques</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jt'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_facture_acquittee_frais_obseque) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even" v-if="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_capital_champ_libre1)">
                <b-col sm="2"><b>{{ dossier.deces_beneficiaire[0].libelle_capital_champ_libre1 }}</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_champ_libre1) }}
                </b-col>
              </b-row>
              <b-row :class="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_capital_champ_libre1) ? 'synthese-odd' : 'synthese-even'" v-if="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_capital_champ_libre2)">
                <b-col sm="2"><b>{{ dossier.deces_beneficiaire[0].libelle_capital_champ_libre2 }}</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_champ_libre2) }}
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">7</b-badge> <b>Concernant les bénéficiaires de rente éducation et rente conjoint</b></span>
            </div>
            <b-card-text class="p-1">
              <b-row class="mb-2">
                <b-col sm="2"><b>Nom</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="beneficiaire.id" >
                  <b>{{ beneficiaire.prenom+' '+beneficiaire.nom }}</b><br>
                  <span class="smaller" v-html="getRentesLibelle(beneficiaire)"></span>
                </b-col>
              </b-row>
              <b-row class="synthese-even">
                <b-col sm="2"><b>RIB</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ribr'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_rib) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd">
                <b-col sm="2"><b>Justificatif de domicile</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jdr'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_justificatif_domicile) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even">
                <b-col sm="2"><b>Extrait acte de naissance</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'an'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_extrait_acte_naissance) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd">
                <b-col sm="2"><b>Pièce d'identité</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'pir'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_piece_identite) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even">
                <b-col sm="2"><b>Certificat de scolarité</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'cs'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_certificat_scolarite) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd">
                <b-col sm="2"><b>Attestation SS étudiant</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'sse'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_attestation_ss_etudiant) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even">
                <b-col sm="2"><b>Contrat d'apprentissage</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'cap'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_contrat_apprentissage) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd">
                <b-col sm="2"><b>Jugement de tutelle</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jtr'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_jugement_tutelle) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even">
                <b-col sm="2"><b>Attestation inscription Pôle Emploi</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'pe'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_attestation_inscription_pole_emploi) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd">
                <b-col sm="2"><b>Carte d'invalidité / Attest. MDPH</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ci'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_carte_invalidite_mdph) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even">
                <b-col sm="2"><b>Attest. Rente substitutive de conjoint</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'rsc'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_attestation_rente_substitutive_conjoint) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd" v-if="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_rente_champ_libre1)">
                <b-col sm="2"><b>{{ dossier.deces_beneficiaire[0].libelle_rente_champ_libre1 }}</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_champ_libre1) }}
                </b-col>
              </b-row>
              <b-row :class="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_rente_champ_libre1) ? 'synthese-even' : 'synthese-odd'" v-if="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_rente_champ_libre2)">
                <b-col sm="2"><b>{{ dossier.deces_beneficiaire[0].libelle_rente_champ_libre2 }}</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_champ_libre2) }}
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="danger" class="float-right ml-2" @click="closeModal">Fermer</b-button>
          <b-button variant="primary" class="float-right ml-2" @click="generatePdfCompletude()"> Export PDF</b-button>
        </div>
      </template>
    </b-modal>

    <!-- Décès Envoi Mutex : Choix de la rubrique et des pièces jointes à envoyer -->
    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop id="modal-rubrique-pj" ref="modal-rubrique-pj" title="Choisissez la rubrique et les pièces jointes à envoyer" ok-only ok-title="Fermer">
      <label><strong>Rubrique : </strong></label>
      <b-row v-for="rubrique in rubriques" :key="rubrique.key">
        <b-col sm="12">
          <b-form-checkbox
            :id="`checkbox-${rubrique.key}`"
            v-model="rubriquesNeeded"
            :name="`checkbox-${rubrique.key}`"
            :value="rubrique.label"
            :state="errors.rubriquesNeeded !== '' ? false : null"
            @input="clearSelectedError('rubriquesNeeded')"
          >
            {{ rubrique.label }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <span class="field-error d-block mr-1 ">{{ errors.rubriques }}</span>
      <hr>
      <label><strong>Pièces jointes : </strong></label>
      <b-row>
        <b-col sm="6">
          <label>Externe</label>
          <b-row v-for="pj in this.piecesJointesExterne" :key="pj.id">
            <b-col sm="12">
              <span class="field-error">{{ errors.pjNeeded }}</span>
              <b-form-checkbox
                :disabled="pj.size > maxPjMutex"
                :id="`checkbox-pj-mutex-${pj.id}`"
                v-model="pjNeeded"
                :name="`checkbox-${pj.id}`"
                :value="pj"
                :state="errors.pjNeeded !== '' ? false : null"
                @input="clearSelectedError('pjNeeded')"
              >
              <img class="mr-2 icon-size-16" :src="getIconPjSrc(pj)">
              <a href="#" @click.prevent="downloadMailPj(pj)">
                <span v-if="pj.types_pj && pj.types_pj.length >= 1"> {{ reducedFileName(pj.name) }}</span>
                <span v-else :title="pj.name"> {{ reducedFileName(pj.name) }}</span>
              </a>
              <i v-if="pj.size > maxPjMutex" class="ml-2 fa fa-question-circle text-danger" v-b-tooltip.hover title="Ce document est trop volumineux (taille > 20Mo), il ne peut être envoyé par mail"></i>
              <!-- {{ pj.name }} -->
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="6">
          <label>Interne</label>
          <b-row v-for="pj in this.piecesJointesInterne" :key="pj.id">
            <b-col sm="12">
              <span class="field-error">{{ errors.pjNeeded }}</span>
              <b-form-checkbox
                :disabled="pj.size > maxPjMutex"
                :id="`checkbox-pj-mutex-${pj.id}`"
                v-model="pjNeeded"
                :name="`checkbox-${pj.id}`"
                :value="pj"
                :state="errors.pjNeeded !== '' ? false : null"
                @input="clearSelectedError('pjNeeded')"
              >
              <img class="mr-2 icon-size-16" :src="getIconPjSrc(pj)">
              <a href="#">
                <span v-if="pj.types_pj && pj.types_pj.length >= 1"> {{ reducedFileName(pj.name) }}</span>
                <span v-else :title="pj.name"> {{ reducedFileName(pj.name) }}</span>
              </a>
              <i v-if="pj.size > maxPjMutex" class="ml-2 fa fa-question-circle text-danger" v-b-tooltip.hover title="Ce document est trop volumineux, il ne peut être envoyé par mail"></i>
              <!-- {{ pj.name }} -->
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-button variant="danger" class="float-right ml-2" @click="cancelRubriquePj()"><i class="fa fa-cancel"></i>
          Annuler
        </b-button>
        <b-button variant="primary" class="float-right ml-2" @click="checkRubriquePj()">
          <i class="fa fa-save"></i>
          Enregistrer
        </b-button>
      </template>
    </b-modal>

    <!-- Décès Envoi Mutex : Récap et envoi du mail et des pièces jointes à Mutex -->
    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop title="Transmission de dossiers vers Mutex" id="modal-mail-to-mutex" ref="modal-mail-to-mutex" ok-only ok-title="Fermer">
      <b-form>
        <b-row>
          <b-col sm="1">
            <label for="mutexTo">A :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="mutexTo" type="text" v-model="mutexTo" :class="{hasError: errors.mutexTo !== ''}"></b-form-input>
            <span class="field-error">{{ errors.mutexTo }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="mutexCc">Cc :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="mutexCc" type="text" v-model="mutexCc"></b-form-input>
            <!-- <span class="field-error">{{ errors.mutexCc}}</span> -->
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="mutexSubject">Objet :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="mutexSubject" type="text" v-model="mutexSubject" :class="{hasError: errors.mutexSubject !== ''}"></b-form-input>
            <span class="field-error">{{ errors.mutexSubject }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm=8>
            <span v-for="(pj, key) in pjNeeded" :key="key">
              <a v-if="pj.size < maxPjMutex" href="#" @click.prevent="downloadMailPj(pj)">
                <img class="mr-2 icon-size-16" :src="getIconPjSrc(pj)"> {{ pj.name }}
              </a> /
            </span>
            <!-- <ul class="no-padding no-decoration">
              <li v-for="(pj, key) in pjNeeded" :key="key">
                <a v-if="pj.size < maxPjMutex" href="#" @click.prevent="downloadMailPj(pj)">
                  <img class="mr-2 icon-size-16" :src="getIconPjSrc(pj)"> {{ pj.name }}
                </a>
              </li>
            </ul> -->
          </b-col>
        </b-row>
        <hr>
        <b-row class="pre-formatted">
          <ckeditor :editor="editor" v-model="mutexBody" :config="editorConfig"  :class="{hasError: errors.mutexBody !== ''}"></ckeditor>
          <span class="field-error">{{ errors.mutexBody }}</span>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="sendReponseMutex()">
            <i class="fa fa-paper-plane"></i>
            Envoyer
          </b-button>
          <b-button
            variant="success"
            class="float-right"
            @click="$bvModal.show('modal-rubrique-pj')">
            Sélectionner rubrique et PJ
          </b-button>
          <b-button
            variant="danger"
            class="float-right mr-2"
            @click="cancelMailMutex()">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Voir les mails envoyés à Mutex -->
    <b-modal scrollable size="xl" id="modal-mails-mutex-envoye" ref="modal-mails-mutex-envoye" title="Mails envoyé à Mutex" ok-only ok-title="Fermer">
      <b-card v-for="mail in mailsMutex" :key="mail.id">
        <b-card class="block-mail">
          <b-list-group flush>
            <b-list-group-item>
              <b-row>
                <b-col sm="12" class="borded-right">
                  <b-card-text>
                    <b-row :class="`mb-2`">
                      <b-col sm="2">
                        De :
                      </b-col>
                      <b-col sm="9">
                        {{ mail.mail_from }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12" class="borded-right">
                  <b-card-text>
                    <b-row :class="`mb-2`">
                      <b-col sm="2">
                        A :
                      </b-col>
                      <b-col sm="9">
                        {{ mail.mail_to }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12" class="borded-right">
                  <b-card-text>
                    <b-row :class="`mb-2`">
                      <b-col sm="2">
                        Copie :
                      </b-col>
                      <b-col sm="9">
                        {{ mail.mail_cc }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12">
                  <b-row>
                    <b-col sm="2">
                      Pièce(s) jointe(s) :
                    </b-col>
                    <b-col sm="9">
                      <b-row v-for="pj in mail.pieces_jointes" :key="pj.id">
                        <b-col sm="12">
                          {{ pj.name }}
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12">
                  <b-row>
                    <b-col sm="2">
                      Objet :
                    </b-col>
                    <b-col sm="9">
                      {{ mail.subject }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col sm="12">
                  <b-row>
                    <b-col sm="2">
                      Envoyé le :
                    </b-col>
                    <b-col sm="9">
                      {{ formatDateHeure(mail.sent_at) }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-row>
                <b-col class="nopadding" sm="12">
                  <b-card-text v-html="mail.body">
                  </b-card-text>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-card>
    </b-modal>
  </div>
</template>
<script>
  import { isEmpty, getReadableFileSize, downloadFile, getIconSrc as getIconPjSrc } from '@/utils/fileHelper';
  import {espaceGestionRules as rules, hasRule} from "@/utils/rulesHelper"
  import moment from 'moment';
  import {isResponsable} from "@/utils/userHelper";
  import {formatDateTime} from "@/utils/communHelper";
  import {getUser} from "@/utils/auth";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import {getIconPostit, canSeeCritere, cantEditFicheDC} from "@/utils/communHelper";
  import loadingField from "@/components/LoadingField";
  import VueHtml2pdf from "vue-html2pdf";
  import SyntheseCompletude from "@/components/Dossier/DetailsDossier/SyntheseCompletude";
  import SyntheseAssure from "@/components/Dossier/DetailsDossier/SyntheseAssure";
  import {PJ_SIZE_LIMIT_MUTEX} from '@/utils/constants';

  export default {
    name: "DonneesSinistre",
    props: [
      'dossier',
      'allTypes',
      'selectedType'
    ],
    components: {
      loadingField,
      VueHtml2pdf,
      SyntheseCompletude,
      SyntheseAssure
    },
    data() {
      return {
        isEmpty,
        canSeeCritere,
        editor: ClassicEditor,
        editorConfig: {
            allowedContent: true,
            toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'link', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'indent', 'outdent', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo' ],
            language: 'fr'
        },
        getReadableFileSize,
        getIconPjSrc,
        allCanals: [],
        canalOptions: [],
        commentaires: [],
        commentairesOriginaux: [],
        commentairesGestion: [],
        dossierIdForCommentaire: '',
        commentaireToAdd: '',
        isNotTraitementQC: false,
        isUrgentToAdd: false,
        isRelationClientToAdd: false,
        addComHidden: true,
        reponseTo: '',
        reponseCc: '',
        reponseSubject: '',
        reponseBody: '',
        mailId: '',
        mailAttachmentsUploaded: [],
        mailAttachments: [],
        allRegleCumulOption: [],
        signatureMail: `
            &nbsp;<br><br>
            Cordialement,<br><br>
            Votre Gestionnaire Prestations<br>
            <i style="font-size:0.8em;">08 06 06 00 12  Lu-Ve de 8h30 à 17h30 (service gratuit + prix appel)<br>www.ChorumEtVous.fr</i>
          `,
        mails: [],
        mailsMutex: [],
        maxPjMutex: PJ_SIZE_LIMIT_MUTEX,
        allCauseSinistre: [],
        causeSinistreOptions: [],
        codeNsiCauseSinistre: '',
        derniereFinPeriodePayee: '',
        montantDerniereFinPeriodePayee: '',
        infosDernierePeriode: '',
        finished: false,
        minDateDebutPsi: '',
        maxDateFinPsi: '',
        loadingFiche: true,
        ficheNiv2Prestations: 0,
        allFlags: [],
        flagsOption: [],
        attestationRessourceOptions:['Avec ressources','Sans ressource',"Pas d'attestation fournie"],
        mutexTo: 'entreprise1.presta@mutex.fr',
        mutexCc: '',
        mutexSubject: '',
        mutexBody: '',
        mailMutexId: '',
        displayCauseTiers : false,
        rubriques: [
          { key: 'paiement_dossier_iad', label: 'paiement sécurisé, dossier décès IAD' },
          { key: 'validation_dossier_iad_capital_sup_150', label: 'validation du dossier décès IAD, le capital étant supérieur à 150K€' },
          { key: 'validation_dossier_capital_sup_150', label: 'validation du dossier, le capital étant supérieur à 150 K€' },
          { key: 'virement_rib_etranger', label: 'virement à effectuer sur un RIB étranger' },
          { key: 'traitement_rente_ocirp', label: 'traitement des rentes OCIRP' }
        ],
        rubriquesNeeded: [],
        piecesJointes: [],
        pjNeeded: [],
        pjInMessage: '',
        myData: {
          dateReception: '',
          dateReceptionCourrier: '',
          dateCourrierInitialisation: '',
          montantIJSS: '',
          dateDebutSinistre: '',
          dateFinSinistre: '',
          dateFaitGenerateur: '',
          datePam: '',
          dateEffet: '',
          dateDeces: '',
          dateSuspensionContrat: '',
          dateRepriseTempsComplet: '',
          capitalDeces: [],
          typeRente: [],
          allocationsObseques: [],
          typeDeces: '',
          categorieInvalInitial: '',
          categorieInval: '',
          attestationRessource: '',
          tauxInitial: '',
          taux: '',
          numArchives: '',
          numPsi: '',
          numeroEvenementNsi: '',
          commentaire: '',
          rar: '',
          emetteur: '',
          selectedCanal: null,
          dateDebutIndisponible: false,
          fluxSource: '',
          fluxDossier: '',
          // libellePrestation: '',
          cause: '',
          nbJrsIjPayes: '',
          etatEvenement: '',
          montantIJSSNet: '',
          hasMontantIJSSVariant : false,
          IsCauseTiers : false,
          isSalarieSortiEffectif : false,
          isSalarieEnMTT : false,
          // cause_cev: '',
          precision_cause: '',
          exclusion_traitement_auto: false,
          expediteur: '',
          selectedRegleCumul: '',
          causeSinistreId: null,
          dossierIdFaitGenerateur: null,
          selectedFlag: '',
          nonEligibleClotureAuto: '',
          credit: '',
          dateInfoDeces: '',
          sourceInfo: '',
          // numContrat: ''
        },
        errors: {
          commentaire: '',
          causeSinistreId: '',
          datePam: '',
          dateFaitGenerateur: '',
          dateEffet: '',
          dateDeces: '',
          typeDeces: '',
          capitalDeces: '',
          typeRente: '',
          date_au: '',
          date_du: '',
          dateSuspensionContrat: '',
          dateRepriseTempsComplet: '',
          montantIJSS: '',
          dateReception: '',
          dateReceptionCourrier: '',
          dateCourrierInitialisation: '',
          canal: '',
          categorieInvalInitial: '',
          categorieInval: '',
          tauxInitial: '',
          taux: '',
          montantIJSSNet: '',
          reponseTo: '',
          reponseSubject: '',
          reponseBody: '',
          dateInfoDeces: '',
          sourceInfo: '',
          mutexTo: '',
          mutexCc: '',
          mutexSubject: '',
          mutexBody: '',
          rubriques: '',
          rubriquesNeeded: '',
          pjNeeded: '',
          numeroEvenementNsi: '',
          selectedBal: '',
          // numContrat: ''
        },
        dateFinDernierePeriodePayee: '',
        capitalOptions: [
          {code: 'has_capital', name: 'Capital'},
          // {code: 'has_capital_sup_75', name: 'Capital > 75k€ Mutex'},
          {code: 'has_capital_sup_150', name: 'Capital > 150k€ validation direction'},
          {code: 'has_capital_orphelin', name: 'Capital orphelin'},
          {code: 'has_maloration_personne_a_charge', name: 'Majoration personne à charge'},
          {code: 'has_maloration_accident', name: 'Majoration Accident'},
        ],
        rentesOptions: [
          {code: 'has_rente_conjoint', name: 'Rente Conjoint/Viagère'},
          {code: 'has_rente_education', name: 'Rente Education'},
          {code: 'has_rente_temporaire', name: 'Rente temporaire'},
          {code: 'has_rente_ocirp', name: 'Rente OCIRP gérée par Mutex'},
          {code: 'has_rente_viagere_orphelin', name: 'Rente viagère orphelin'},
          {code: 'has_rente_viagere_handicap', name: 'Rente viagère handicap'},
        ],
        allocationsOptions: [
          {code: 'has_allocation_obseque', name: 'Allocations Obsèques'},
        ],
        dcFamilleProduitPdf: [],
        relancesColumns: ["date_relance", "type_relance", "mail_beneficiaire"],
        relancesItems: [],
        // relancesOptions: {
        //   rowClassCallback(row) {
        //     return row.active ? 'highlight' : '';
        //   },
        //   headings: {
        //     date_relance: "Date relance",
        //     type_relance: "Type relance",
        //     mail_beneficiaire: "Mail bénéficiaire"
        //   },
        //   filterable: false,
        //   sortable: []
        // },
        showForward: false,
        balsTransfert: [],
        balsForwardOption: [],
        selectedBal: null,
        commentaireForward: '',
      }
    },
    watch: {
      myData: {
        handler: _.debounce(function (value) {
          this.$event.emit('editDossier', 'DonneesSinistre', value);
        }, 1000),
        deep: true,
      },
      // 'myData.typeRente'(){
      //   this.disableTypeRente();
      // },
      // 'myData.capitalDeces'(){
      //   this.disableCapitalDeces();
      // },
      'errors.dateReception'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.date_du'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.date_au'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.montantIJSS'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.montantIJSSNet'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.dateDeces'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.dateInfoDeces'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.sourceInfo'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.typeDeces'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.capitalDeces'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.typeRente'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.categorieInval'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.categorieInvalInitial'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.dateEffet'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.tauxInitial'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      'errors.taux'(value){
        if(value !== '') {
          this.isNotTraitementQC = true;
        }
      },
      dossier() {
        this.setForm();
        this.getRelancesItems();
      },
      selectedType() {
        this.manageCauseSinistreOption();
      },
      'myData.selectedRegleCumul'(){
        this.manageSelectedRegleCumul();
      },
      'myData.causeSinistreId'() {
        this.setCodeNsiCauseSinistre();
        this.manageAccidentTiers();
      },
      'myData.isSalarieEnMTT'(){
        this.manageIsSalarieEnMTT();
      },
      'myData.isSalarieSortiEffectif'(){
        this.manageIsSalarieSortiEffectif();
      }
    },
    computed: {
      piecesJointesInterne() {
        return _.filter(this.dossier.pieces_jointes, (pj) => pj.is_from_client === false);
      },
      piecesJointesExterne() {
        return _.filter(this.dossier.pieces_jointes, (pj) => {
          // let pjTypeIds = pj.types_pj ? pj.types_pj.map(type => type.id) : [];
          let pjTypeLibTech = pj.types_pj ? pj.types_pj.map(type => type.libelle_technique) : [];
          return pj.is_from_client === true && pjTypeLibTech.indexOf('doublon') === -1 && pjTypeLibTech.indexOf('inutiles') === -1
          // return pj.is_from_client === true && pjTypeIds.indexOf(75) === -1
        });
      },
    },
  created() {
      this.$event.on('saveError', (errors) => {
        this.errors = errors;
      });

      this.$event.on('changeExclusion', (value) => {
        this.myData.exclusion_traitement_auto = value;
      });
      this.$event.on('updateAttestationRessource', (value) => {
        this.myData.attestationRessource = value
      })
      this.setMaxDatesPsi()
      this.getFicheNiv2PrestationsCount();
      this.getRelancesItems();
      this.getCanals();
    },
    async mounted() {
      await this.getCauseSinistre();

      this.getBalForward();
      this.setForm();
      this.setCommentaires();
      this.setMailEnoye();
      this.isNotTraitementQC = !this.$parent.$parent.$parent.isQualification;
      this.getReglesCumul();
      this.getFlags();
      this.getDerniereFinPeriodePayee();
      this.getDcFamilleProduitPdf();
      this.setMailMutexEnvoye();
    },
    methods: {
      generatePdfCompletude() {
        this.$refs.html2Pdf.generatePdf();
      },
      generatePdfAssure() {
        this.$refs.html2PdfAssure.generatePdf();
      },
      getDcFamilleProduitPdf() {
        this.dcFamilleProduitPdf = this.$parent.$parent.$parent.allFamillesProduits
      },
      formatDateJs(textDate) {
        let date = textDate !== null ? moment(textDate).format('YYYY-MM-DD') : "-";
        return date;
      },
      setMaxDatesPsi() {
        // min date début 5 ans avant date réception
        let date_reception = new Date(this.dossier.date_reception)
        this.minDateDebutPsi = date_reception.setFullYear(date_reception.getFullYear() - 5)
        this.minDateDebutPsi = this.formatDateJs(this.minDateDebutPsi).toString()
        // max date fin dernier jour du mois en cours
        let today = new Date();
        this.maxDateFinPsi = new Date(today.getFullYear(), today.getMonth()+1, 0);
        this.maxDateFinPsi = this.formatDateJs(this.maxDateFinPsi).toString()
      },
      async setForm() {
        this.myData.dateReception = this.formatDate(this.dossier.date_reception);
        this.myData.dateReceptionCourrier = this.formatDate(this.dossier.date_reception_courrier);
        if (this.getTypeDossier() === 'dc') {
          if (isEmpty(this.dossier.fiche_deces) || isEmpty(this.dossier.fiche_deces.date_courrier_initialisation)) {
            // let dateInit = await this.getDateCourrierInitialisation();
            // this.myData.dateCourrierInitialisation = dateInit;
            this.getDateCourrierInitialisation()
              .then(dateInit => {
              this.myData.dateCourrierInitialisation = this.formatDate(dateInit);
            })
          } else {
            this.myData.dateCourrierInitialisation = this.formatDate(this.dossier.fiche_deces.date_courrier_initialisation);
          }
        }

        this.myData.montantIJSS = this.dossier.montant_ij_ss;
        this.myData.hasMontantIJSSVariant = this.dossier.dossier_ij ? this.dossier.dossier_ij.has_montant_ij_ss_variant : false;
        this.myData.IsCauseTiers = this.dossier.dossier_ij ? this.dossier.dossier_ij.is_cause_tiers : false;
        this.myData.isSalarieSortiEffectif = this.dossier.dossier_ij ? this.dossier.dossier_ij.is_salarie_sorti_effectif : false;
        this.myData.dateSuspensionContrat = this.dossier.dossier_ij ? this.dossier.dossier_ij.date_suspension_contrat : null;
        this.myData.dateRepriseTempsComplet = this.dossier.dossier_ij ? this.dossier.dossier_ij.date_reprise_temps_complet : null;
        this.myData.isSalarieEnMTT = this.dossier.dossier_ij ? this.dossier.dossier_ij.is_salarie_en_mtt : false;
        this.myData.dateDebutSinistre = this.dossier.date_debut_periode;
        this.myData.dateFinSinistre = this.dossier.date_fin_periode;
        this.myData.dateFaitGenerateur = this.dossier.date_fait_generateur;
        this.myData.datePam = this.dossier.date_pam;
        this.myData.dateEffet = this.dossier.date_effet;
        this.myData.dateInfoDeces = this.dossier.fiche_deces ? (!isEmpty(this.dossier.fiche_deces.date_information_deces) ? this.dossier.fiche_deces.date_information_deces : this.dossier.date_reception) : this.dossier.date_reception;
        this.myData.sourceInfo = this.dossier.fiche_deces ? this.dossier.fiche_deces.source_information : '';
        this.myData.dateDeces = this.dossier.fiche_deces ? this.dossier.fiche_deces.date_deces : '';
        this.myData.typeDeces = this.dossier.fiche_deces ? this.dossier.fiche_deces.type_deces : '';
        this.myData.categorieInvalInitial = this.dossier.categorie_inval_initial;
        this.myData.categorieInval = this.dossier.categorie_inval;
        this.myData.attestationRessource = this.dossier.inval ? this.dossier.inval.attestation_ressource : 'Pas d\'attestation fournie';
        if (this.dossier.capital_verse) {
          this.myData.capitalDeces.push('capital');
        }
        if (this.dossier.capital_superieur) {
          this.myData.capitalDeces.push('capital_plus');
        }
        if (this.dossier.rente_conjoint) {
          this.myData.typeRente.push('conjoint');
        }
        if (this.dossier.rente_education) {
          this.myData.typeRente.push('education');
        }
        if (this.dossier.rente_ocirp) {
          this.myData.typeRente.push('ocirp');
        }
        if (this.dossier.has_allocations_obseques) {
          this.myData.allocationsObseques.push('allocationsObseques');
        }
        this.myData.selectedCanal = this.dossier.canal_id;
        this.myData.taux = this.dossier.taux_incapacite;
        this.myData.tauxInitial = this.dossier.taux_incapacite_initial;
        this.myData.rar = this.dossier.rar;
        this.myData.emetteur = this.dossier.emetteur;
        this.myData.numPsi = this.dossier.numero_psi;
        this.myData.numeroEvenementNsi = this.dossier.numero_evenement_nsi;
        this.myData.fluxSource = this.dossier.flux_source;
        this.myData.fluxDossier = this.dossier.flux_dossier;
        this.myData.libellePrestation = this.dossier.libelle_prestation_flux;
        // this.myData.cause = this.dossier.cause_flux;
        this.myData.etatEvenement = this.dossier.etat_evenement_flux;
        this.myData.nbJrsIjPayes = this.dossier.nb_jour_ij_payes_flux;
        this.myData.montantIJSSNet = this.dossier.montant_ij_ss_net;
        // this.myData.cause_cev = this.dossier.cause_cev;
        // this.myData.cause_sinistre_id = this.dossier.cause_sinistre_id;
        // this.myData.precision_cause = this.dossier.cause_maladie_cev;
        this.myData.precision_cause = !isEmpty(this.dossier.precision_cause) ? this.dossier.precision_cause : (!isEmpty(this.dossier.cause_maladie_cev) ? this.dossier.cause_maladie_cev : (!isEmpty(this.dossier.libelle_prestation_flux) ? this.dossier.libelle_prestation_flux : ''));
        this.myData.causeSinistreId = this.dossier.cause_sinistre_id;
        this.myData.dossierIdFaitGenerateur = this.dossier.dossier_id_fait_generateur;
        //this.myData.exclusion_traitement_auto = this.dossier.is_exclude_traitement_auto ? 'exclusion' : false;
        this.myData.selectedRegleCumul = this.dossier.regle_cumul_id ? this.dossier.regle_cumul.libelle_technique : 'sans_rc';

        // Gestion des flags, il ne faut pas prendre en compte les flags admin
        // let selectedFlag = !isEmpty(this.dossier.flags) ? this.dossier.flags.reduce((res, item) => item.type !== 'admin' ? item.id : res,'') : '';
        this.myData.selectedFlag = !isEmpty(this.dossier.flags) ? this.dossier.flags.reduce((res, item) => item.type !== 'admin' ? item.id : res,'') : '';
        this.myData.nonEligibleClotureAuto = this.dossier.is_non_eligible_cloture_auto ? 'nonEligible' : '';
        this.myData.credit = this.dossier.credit;

        if (this.dossier.mail && this.dossier.mail.mail_from) {
          this.myData.expediteur = this.dossier.mail.mail_from
        } else if (this.dossier.mail_declarant_sinistre) {
          this.myData.expediteur = this.dossier.mail_declarant_sinistre
        }
        this.setCodeNsiCauseSinistre();
      },
      getFicheNiv2PrestationsCount() {
        if (!isEmpty(this.dossier.nir)) {
          let self = this;
          this.loadingFiche = true;
          let nir = this.dossier.nir.length > 13 ? this.dossier.nir.substring(0,13) : this.dossier.nir;
          this.$axios
            .get("/espaceGestion/dossier/ficheNiv2Prestations/"+this.dossier.siren+"/"+nir)
            .then(response => {
              this.loadingFiche = false;
              this.ficheNiv2Prestations = response.data.result;
            })
            .catch((error) => {
              // console.log(error)
              self.loadingFiche = false;
            });
        } else {
          this.loadingFiche = false;
          this.ficheNiv2Prestations = 0;
        }

      },
      getSrc() {
        const dgpoUrlBase = process.env.VUE_APP_DGPO_URL;
        let dateCalculee = new Date();
        dateCalculee.setMonth(dateCalculee.getMonth() - 2); // Les mois commencent à 0, donc pour enlever 3 mois il faut faire -2
        let urlDate = String(dateCalculee.getDate()).padStart(2, '0') + '/' + String(dateCalculee.getMonth()).padStart(2, '0') + '/' + String(dateCalculee.getFullYear()).substring(2,4);
        let nir1 = this.dossier.nir.substring(0, 13)
        let nir2 = this.dossier.nir.substring(13, 15)

        return dgpoUrlBase + 'fiche/recherche/resultat?structure_siren=' + this.dossier.siren + '&beneficiaire_nir1=' + nir1  + '&date_debut=' + urlDate;
      },
      formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
      },
      getDerniereFinPeriodePayee() {
        let self = this;
        if (!isEmpty(this.dossier.date_derniere_psi_paye)) {
          this.dateFinDernierePeriodePayee = this.formatDateFinPeriode(this.dossier.date_derniere_psi_paye)
        } else {
          this.dateFinDernierePeriodePayee = "Aucun décompte trouvé";
        }
        return this.dateFinDernierePeriodePayee
      },
      getCanals() {
        this.$axios
          .get("/espaceGestion/dossier/getAllCanal")
          .then(response => {
            this.allCanals = response.data.data;
            for (let canal of response.data.data) {
              this.canalOptions.push({value: canal.id, text: canal.libelle});
            }
          });
      },
      getCauseSinistre() {
        return new Promise((resolve, reject) => {
          let self = this;
          this.$axios
            .get("/espaceGestion/dossier/getAllCauseSinistre")
            .then(response => {
              this.allCauseSinistre = response.data.causes
              this.manageCauseSinistreOption();
              resolve();
            })
            .catch((error) => {
              let errorText = 'Une erreur est survenue lors de la récupération des causes sinistres. Si le problème persiste, merci de faire un ticket au support DOSI.'
              self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text:errorText,
                showConfirmButton: false,
                timer: 5000
              });
            });
        });
      },
      setCodeNsiCauseSinistre() {
        let causeSinistre = this.allCauseSinistre.find(cause => cause.id === parseInt(this.myData.causeSinistreId,10));
        this.codeNsiCauseSinistre = !isEmpty(causeSinistre) ? causeSinistre.code_nsi : '';
      },
      manageAccidentTiers(){
        if(this.codeNsiCauseSinistre === 'ACTR'){
          this.displayCauseTiers = true;
        }else{
          this.displayCauseTiers = false;
          this.myData.IsCauseTiers = false;
        }
      },
      manageIsSalarieEnMTT(){
        if(this.myData.isSalarieEnMTT === true){
          this.myData.isSalarieSortiEffectif = false;
          this.myData.selectedRegleCumul = 'tpt';
        }else{
          if(this.myData.isSalarieSortiEffectif === false){
            if(this.myData.selectedRegleCumul != 'inf_150h'){
              this.myData.selectedRegleCumul = 'sans_rc';
            }
          }
        }
      },
      manageIsSalarieSortiEffectif(){
        if(this.myData.isSalarieSortiEffectif === true){
          this.myData.isSalarieEnMTT = false;
          this.myData.selectedRegleCumul = 'rupc';
        }else{
          if(this.myData.isSalarieEnMTT === false){
            if(this.myData.selectedRegleCumul != 'inf_150h'){
              this.myData.selectedRegleCumul = 'sans_rc';
            }
          }
        }
      },
      manageSelectedRegleCumul(){
        if(this.myData.selectedRegleCumul === 'rupc'){
          this.myData.isSalarieEnMTT = false;
          this.myData.isSalarieSortiEffectif = true
        }else if(this.myData.selectedRegleCumul === 'tpt'){
          this.myData.isSalarieEnMTT = true;
          this.myData.isSalarieSortiEffectif = false;
        }else{
          this.myData.isSalarieEnMTT = false;
          this.myData.isSalarieSortiEffectif = false;
        }
      },
      manageCauseSinistreOption() {
        let typeDossier = null;
        this.causeSinistreOptions = [];

        typeDossier = this.getTypeDossier();
        for (let cause of this.allCauseSinistre) {
          if(typeDossier) {
            if(cause.type.toLowerCase().indexOf(typeDossier) > -1) {
              this.causeSinistreOptions.push({value: cause.id, text: cause.libelle});
            }
          } else {
            this.causeSinistreOptions.push({value: cause.id, text: cause.libelle});
          }
        }
      },
      isDisabled(field) {
        return this.$parent.$parent.$parent.isDisabled(field)
      },
      formatDate(textDate) {
        let formattedDate = null;
        if (!isEmpty(textDate) && textDate !== 'Invalid date') {
          let date = new Date(textDate).toLocaleDateString("fr-FR").split('/');
          formattedDate = `${date[2]}-${date[1]}-${date[0]}`;
        }
        return formattedDate;
      },
      formatDateFinPeriode(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      formatDateSynthese(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "--/--/----";
      },
      editCommentaire(dossier) {
        this.commentairesGestion = dossier.commentaires_gestion;
        this.dossierIdForCommentaire = dossier.id;
        this.$refs['modal-commentaire'].show();
      },
      async saveCommentaire() {
        if (this.validateCommentaires()) {
          let self = this;
          let dataPost = {
            'dossierId': this.dossierIdForCommentaire,
            'commentaireExistant': this.commentaires,
            'newCommentaireTexte': this.commentaireToAdd,
            'newCommentaireIsUrgent': this.isUrgentToAdd,
            'newCommentaireIsRelationClient': this.isRelationClientToAdd,
          };
          // On commence par enregistrer les éventuelles modifications dans la fiche dossier pour ne pas perdre les données lors du refresh du dossier
          await this.$parent.$parent.$parent.save('save');
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post('/espaceGestion/dossier/commentaire', dataPost)
            .then(response => {
              this.$event.emit('refreshDossier');
              this.$store.commit('IS_LOADING', false);
              this.closeModal();
              this.dossier.commentaires_gestion = response.data.commentaires;
              this.setCommentaires();
              this.$swal({
                position: "top",
                type: "success",
                title: "Succès !",
                text: 'Commentaire bien enregistré',
                showConfirmButton: false,
                timer: 3000
              });
            })
            .catch(function (error) {
              // console.log(error);
              let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
              if (error.response.status === 400) {
                textError = 'Vous devez saisir un commentaire';
              }
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: textError,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      canDeleteCommentaire(commentaire) {
        let user = getUser();
        return !isEmpty(commentaire.gestionnaire) && (isResponsable() || parseInt(commentaire.gestionnaire.id,10) === parseInt(user.id,10));
      },
      deleteCommentaire(commentaire) {
        let self = this;
        let data = {};
        let dossier_id = commentaire.dossier_id;

        data.traitementId = this.$route.query.traitementId;
        // console.log('this.$axios',this.$axios)
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer ce commentaire ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:'#ff1744',
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {
            data.commentaireId = commentaire.id;
            data.dossierId = dossier_id;
            this.$store.commit('IS_LOADING', true);
            this.$axios
              .post('/espaceGestion/dossier/commentaire/delete',data)
              .then(response => {
                this.$store.commit('IS_LOADING', false);
                // this.$event.emit('refreshDossier');
                this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le commentaire a bien été supprimé',showConfirmButton: false, timer: 3000});
                this.dossier.commentaires_gestion = response.data.commentaires;
                this.setCommentaires();
                // on met à jour les commentaires affichés dans le modal
                this.commentairesGestion = response.data.commentaires;
              })
              .catch(function(error){
                // console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression du commentaire. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      closeModal() {
        this.$refs['modal-commentaire'].hide();
        this.$refs['modal-synthese'].hide();
        this.$refs['modal-synthese-assure'].hide();
        this.remiseAZero();
      },
      remiseAZero() {
        this.addComHidden = true;
        this.commentaireToAdd = '';
        this.isUrgentToAdd = false;
        this.isRelationClientToAdd = false;
        this.commentairesGestion = [];
        this.dossierIdForCommentaire = '';
        this.clearError();
      },
      validateCommentaires() {
        let error = false;

        for (let commentaireKey in this.commentaires) {
          if (commentaireKey === undefined) {
            continue;
          }
          if (this.commentaires[commentaireKey].texte === '') {
            error = true;
            this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide';
          }
        }
        if (this.commentaireToAdd.trim() === '' && this.isUrgentToAdd === true) {
          error = true;
          this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide';
        }

        if (this.commentaireToAdd.trim() === '' && this.isRelationClientToAdd === true) {
          error = true
          this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide'
        }
        return !error;
      },
      getTypeDossier() {
        let selectedType = this.allTypes.reduce((res,type) => parseInt(type.id,10) === parseInt(this.selectedType,10) ? type : res,{});

        return !isEmpty(selectedType) ? selectedType.groupe.toLowerCase() : '';
      },
      getTypeInval() {
        let typeIncapcite = ['incao','incact'];
        let selectedType = this.$parent.$parent.$parent.allTypes.reduce((res,type) => parseInt(type.id,10) === parseInt(this.$parent.$parent.$parent.selectedType,10) ? type : res,{});
        return !isEmpty(selectedType) ? (typeIncapcite.indexOf(selectedType.libelle_technique) > -1 ? 'incap' : 'inval') : '';
      },
      getTooltip() {
        let tooltip = '';
        for (let commentaire of this.commentairesOriginaux) {
          if(!isEmpty(commentaire)) {
            tooltip = tooltip + commentaire.texte + '\n';
          }
        }
        return tooltip;
      },
      getIconSrc(type, dossier) {
        return getIconPostit(type, dossier);
      },
      formatDateHeure(textDate) {
        return formatDateTime(textDate, '/');
      },
      clearError() {
        this.errors.commentaire = '';
        this.errors.datePam = '';
        this.errors.dateDeces = '';
        this.errors.type_deces = '';
        this.errors.dateEffet = '';
        this.errors.date_au = '';
        this.errors.date_du = '';
        this.errors.montantIJSS = '';
        this.errors.montantIJSSNet = '';
        this.errors.dateReception = '';
        this.errors.dateReceptionCourrier = '';
        this.errors.dateCourrierInitialisation = '';
        this.errors.canal = '';
        this.errors.categorieInval = '';
        this.errors.capitalDeces = '';
        this.errors.typeRente = '';
        this.errors.rubriques = '';
      },
      onPastePsi(evt, type) {
        evt.stopPropagation();
        evt.preventDefault();
        let clipboardData = evt.clipboardData || window.clipboardData;
        let pastedData = clipboardData.getData('Text');
        pastedData = moment(pastedData, 'DD/MM/YYYY').format('YYYY-MM-DD');

        if(type === 'debut') {
          this.myData.dateDebutSinistre = this.formatDate(pastedData);
          if (this.myData.dateDebutSinistre < this.minDateDebutPsi) {
            this.errors.date_du = 'Saisissez une date à maximum 5 ans avant la date de réception';
          } else {
            this.errors.date_du = ''
          }
        } else if(type === 'fin') {
          this.myData.dateFinSinistre = this.formatDate(pastedData);
          if (this.myData.dateFinSinistre > this.maxDateFinPsi) {
            this.errors.date_au = 'Saisissez une date à maximum au dernier jour du mois';
          } else {
            this.errors.date_au = ''
          }
        }
      },
      onPaste(evt, type) {
        evt.stopPropagation();
        evt.preventDefault();
        let clipboardData = evt.clipboardData || window.clipboardData;
        let pastedData = clipboardData.getData('Text');
        pastedData = moment(pastedData, 'DD/MM/YYYY').format('YYYY-MM-DD');

        if(type === 'debut') {

          this.myData.dateDebutSinistre = this.formatDate(pastedData);
        } else if(type === 'fin') {
          this.myData.dateFinSinistre = this.formatDate(pastedData);
        }
      },
      setCommentaires() {
        this.commentaires = {};
        this.commentairesOriginaux = [];
        for (let commentaire of this.dossier.commentaires_gestion) {
          if(!isEmpty(commentaire)) {
            this.commentaires[commentaire.id] = {
              texte: commentaire.texte,
              is_urgent: commentaire.is_urgent,
              is_relation_client: commentaire.is_relation_client
            }
            this.commentairesOriginaux[commentaire.id] = {
              texte: commentaire.texte,
              is_urgent: commentaire.is_urgent,
              is_relation_client: commentaire.is_relation_client
            }
          }
        }
      },
      isTypeDossierByLibelleTechnique(libelle_technique) {
        // Gestion Invalidité : Ouverture ==> 'ino'
        // Gestion Invalidité : Changement de catégorie ==> 'invcc'
        // Gestion Incapacité : Ouverture ==> 'incao'
        // Gestion Incapacité : Changement de taux ==> 'incact'
        let selectedType = this.$parent.$parent.$parent.allTypes.reduce((res,type) => parseInt(type.id,10) === parseInt(this.$parent.$parent.$parent.selectedType,10) ? type : res,{});
        return !isEmpty(selectedType) ? selectedType.libelle_technique === libelle_technique : false;
        // return this.dossier.type ? this.dossier.type.libelle_technique === libelle_technique : false;
      },
      // disableTypeRente() {
      //   // let inputConjoint = document.getElementById('conjoint');
      //   let inputEduc = document.getElementById('education');
      //   let inputOcirp = document.getElementById('ocirp');
      //   // inputConjoint.disabled = this.myData.typeRente.indexOf('ocirp') > -1;
      //   inputEduc.disabled = this.myData.typeRente.indexOf('ocirp') > -1;
      //   inputOcirp.disabled = this.myData.typeRente.indexOf('education') > -1;
      // },
      // disableCapitalDeces() {
      //   let inputCapital = document.getElementById('capital');
      //   let inputCapitalPlus = document.getElementById('capital_plus');
      //   inputCapital.disabled = this.myData.capitalDeces.indexOf('capital_plus') > -1;
      //   inputCapitalPlus.disabled = this.myData.capitalDeces.indexOf('capital') > -1;
      // },
      initiateMail(type) {
        if (type === 'create' && isEmpty(this.reponseBody)) {
          this.reponseTo = this.myData.expediteur;
          this.reponseBody = this.signatureMail;
        } else if (type === 'continue') {
          let mail = this.dossier.mail_envoye.find( mailSaved => isEmpty(mailSaved.sent_at) && mailSaved.type === 'standard');
          this.reponseTo = mail.mail_to;
          this.reponseCc = mail.mail_cc;
          this.reponseSubject = mail.subject;
          this.reponseBody = mail.body;
          this.mailId = mail.id;
          this.mailAttachmentsUploaded = mail.pieces_jointes;
        }

        this.$refs['modal-mail-to-client'].show();
      },
      sendReponse(type) {
        this.clearErrorsMail();
        if (type === 'send') {
          if (this.validateMail()) {
            this.sendMail(type);
          }
        } else {
          this.sendMail(type);
        }
      },
      async sendMail(type) {
        let self = this;
        let formData = new FormData();
        for( var i = 0; i < this.mailAttachments.length; i++ ){
            let file = this.mailAttachments[i];
            formData.append('files[' + i + ']', file);
        }
        formData.append('mail_to', this.reponseTo);
        formData.append('mail_cc', this.reponseCc);
        formData.append('subject', this.reponseSubject);
        formData.append('body', this.reponseBody);
        formData.append('type', type);
        formData.append('dossier_id', this.dossier.id);
        formData.append('mail_id', this.mailId);
        formData.append('traitement_id', this.$route.query.traitementId);

        // On commence par enregistrer les éventuelles modifications dans la fiche dossier pour ne pas perdre les données lors du refresh du dossier
        await this.$parent.$parent.$parent.save('save');
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .post('/espaceGestion/dossier/send-mail', formData)
          .then(response => {
            this.$event.emit('refreshDossier');
            this.$store.commit('IS_LOADING', false);
            this.mailAttachments = [];
            this.$refs['modal-mail-to-client'].hide();
            this.$swal({
              position: "top",
              type: "success",
              title: "Succès !",
              text: type === 'send' ? 'Mail correctement envoyé.' : 'Mail enregistré avec succès.',
              showConfirmButton: false,
              timer: 3000
            });
          })
          .catch(function (error) {
            // console.log(error);
            let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
            if (error.response && error.response.status === 424) {
              textError = error.response.data.message;
            }
            self.$refs['modal-mail-to-client'].hide();
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: textError,
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      showSentMail() {
        this.$refs['modal-mails-envoye'].show();
      },
      deleteMail() {
        let self = this;
        let mail = this.dossier.mail_envoye.find(mail => isEmpty(mail.sent_at));

        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer le brouillon du mail à envoyer au client ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {

            this.$store.commit('IS_LOADING', true)
            this.$axios
              .delete("/espaceGestion/dossier/mail/delete/"+mail.id)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.$event.emit('refreshDossier');
                this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le brouillon de mail a bien été supprimé',showConfirmButton: false, timer: 3000})
              })
              .catch(function(error){
                // console.log(error)
                let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                if (error.response && error.response.status === 424) {
                  textError = error.response.data.message;
                }
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:textError, showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      validateMail() {
        let valid = true;
        if (isEmpty(this.reponseTo)) {
          valid = false;
          this.errors.reponseTo = 'Vous devez entrer une adresse de destination.'
        }
        if (isEmpty(this.reponseSubject)) {
          valid = false;
          this.errors.reponseSubject = 'Vous devez spécifier l\'objet du mail.'
        }
        if (isEmpty(this.reponseBody) || this.reponseBody === this.signatureMail) {
          valid = false;
          this.errors.reponseBody = 'Vous devez saisir un message.'
        }
        return valid;
      },
      addFileToMail(event) {
        this.mailAttachments = event.target.files;
      },
      downloadMailPj(pj) {
        let self = this
        let fileNameArr = pj.name.split('.')
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');
        this.$axios
          .get("/espaceGestion/dossier-pieces-jointes/download/"+pj.id, {responseType: 'arraybuffer'})
          .then(response => {
            downloadFile(response, name, ext);
          })
          .catch(() => {
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 4000
            });
          })
      },
      deleteMailPj(pj) {
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment supprimer cette pièce jointe ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Supprimer"
          })
          .then(result => {
            if (!result.value) {
              let self = this;
              let data = {};
              data.traitementId = this.$route.query.traitementId;
              data.type = 'mail_envoye';
              data.mailId = this.mailId;
              this.$store.commit("IS_LOADING", true);

              this.$axios
                .post("/espaceGestion/dossier-pieces-jointes/delete/"+pj.id,data)
                .then(response => {
                  this.$store.commit("IS_LOADING", false);
                  this.mailAttachmentsUploaded = this.mailAttachmentsUploaded.filter(pjUploaded => pj.id !== pjUploaded.id);

                  this.$swal(
                    {
                      position: 'top',
                      type: 'success',
                      title: 'Suppression',
                      text: 'La pièce jointe a été correctement supprimée.',
                      showConfirmButton: false,
                      timer: 5000
                    })
                })
                .catch(function(error) {
                  self.$store.commit("IS_LOADING", false);
                  self.$swal({
                    position: "top",
                    type: "error",
                    title: "Attention !!",
                    text: "Une erreur est survenue lors de la suppression de la pièce jointe, si le problème persiste merci de faire un ticket au support DOSI",
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          })
      },
      formatNames(files) {
        if (files.length === 1) {
          return files[0].name
        } else {
          return `${files.length} fichiers selectionnés`
        }
      },
      canShowCreate() {
        let can = true;
        for (let mail of this.dossier.mail_envoye) {
          if(mail.type === 'standard' && isEmpty(mail.sent_at)){
              can = false;
          }
        }
        return can;
      },
      canShowSentMail() {
        let can = false;
        for (let mail of this.dossier.mail_envoye) {
          if(mail.type === 'standard' && !isEmpty(mail.sent_at)){
              can = true;
          }
        }
        return can;
      },
      clearErrorsMail() {
        this.errors.reponseTo = '';
        this.errors.reponseSubject = '';
        this.errors.reponseBody = '';
        this.errors.mutexTo = '';
        this.errors.mutexSubject = '';
        this.errors.mutexBody = '';
      },
      setMailEnoye() {
        let mailsEnoye = this.dossier.mail_envoye ? this.dossier.mail_envoye.filter(mail => !isEmpty(mail.sent_at) && mail.type === 'standard') : [];
        this.mails = mailsEnoye;
      },
      getReglesCumul() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getReglesCumul")
          .then(response => {
            this.allRegleCumul = response.data.data;
            for (let regleCumul of response.data.data) {
              this.allRegleCumulOption.push({value: regleCumul.libelle_technique, text: regleCumul.libelle});
            }
          })
          .catch((error) => {
            // console.log(error)
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue lors de la récupération de la liste des règles de cumul, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      getFlags() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getFlags")
          .then(response => {
            this.allFlags = response.data.data;
            this.flagsOption.push({value: '', text: 'Aucun flag'});
            for (let flag of response.data.data) {
              if (flag.type != 'admin') {
                this.flagsOption.push({value: flag.id, text: flag.libelle});
              }
            }
          })
          .catch((error) => {
            // console.log(error)
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue lors de la récupération de la liste des motifs de non prise en charge, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      canSeeCaseReclamation() {
        return hasRule(rules.CAN_SEE_CASE_RECLAMATION)
      },
      showSynthese(type) {
        if (type === 'assure') {
          this.$refs['modal-synthese-assure'].show();
        } else {
          this.$refs['modal-synthese'].show();
        }
      },
      getLibelleFamilleProduit(familleId) {
        let familleProduit = this.$parent.$parent.$parent.allFamillesProduits.find(famille => parseInt(famille.value,10) === parseInt(familleId,10));
        return !isEmpty(familleProduit) ? familleProduit.text : '';
      },
      getCapitalDecesLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.capital)) {
          for (let capital of this.capitalOptions) {
            if (beneficiaire.capital.indexOf(capital.code) > -1) {
              libelle = libelle + capital.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      getRentesLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.rentes)) {
          for (let rente of this.rentesOptions) {
            if (beneficiaire.rentes.indexOf(rente.code) > -1) {
              libelle = libelle + rente.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      getAllocationsLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.allocations)) {
          for (let allocation of this.allocationsOptions) {
            if (beneficiaire.allocations.indexOf(allocation.code) > -1) {
              libelle = libelle + allocation.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      getDateCourrierInitialisation() {
        return new Promise(async (resolve, reject) => {
          let self = this;
          let dateFirstDpc = '';
          this.$axios
            .get("/espaceGestion/incidents/dossierId/" + this.dossier.id)
            .then(response => {
              for (let incident of response.data.incidents) {
                if (incident.dpc && !isEmpty(incident.dpc.sent_at)) {
                  dateFirstDpc = isEmpty(dateFirstDpc) ? incident.dpc.sent_at : (dateFirstDpc > incident.dpc.sent_at ? incident.dpc.sent_at : dateFirstDpc);
                }
              }
              resolve(dateFirstDpc);
            })
            .catch((error) => {
              // console.log(error)
              let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
              self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text:errorText,
                showConfirmButton: false,
                timer: 5000
              })
              resolve('');
            })
        })
      },
      initiateMailMutex() {
        this.mutexBody = '<p>Madame, Monsieur, </p>';
        this.mutexBody = this.mutexBody + '<p>Nous vous prions de bien vouloir trouver ci-joint les pièces relatives au dossier décès de Monsieur/Madame <strong>' + this.dossier.nom + ' ' + this.dossier.prenom + '</strong>, pour :</p>';
        if (!isEmpty(this.rubriquesNeeded)) {
          for (let rubrique of this.rubriquesNeeded) {
            this.mutexBody = this.mutexBody + '- ' + rubrique + '<br>';
          }
          // this.mutexBody = this.mutexBody + '- ' + this.rubriquesNeeded;
        } else {
          this.mutexBody = this.mutexBody + '- [rubrique]';
        }
        this.mutexBody = this.mutexBody + '<p>Pour mémoire,<br>';
        this.mutexBody = this.mutexBody + 'le capital a été validé par Chorum le [XX / XX / XXXX]<br>';
        this.mutexBody = this.mutexBody + 'le capital a été mis en paiement le [XX / XX/ XXXX]<br></p>';
        this.mutexBody = this.mutexBody + '<p>Pour toute demande sur le suivi de ce dossier, merci de bien vouloir répondre par retour de ce mail.</p>';
        this.mutexBody = this.mutexBody + '<p>En vous souhaitant bonne réception, nous vous prions d’agréer, Madame, Monsieur, l’expression de nos sincères salutations.</p>';
        this.mutexBody = this.mutexBody + this.signatureMail;
        this.$refs['modal-rubrique-pj'].hide()
        this.$refs['modal-mail-to-mutex'].show();
      },
      cancelRubriquePj() {
        this.$refs['modal-rubrique-pj'].hide()
        this.clearError()
      },
      validateRubriquePj() {
        let valid = true
        if (this.rubriquesNeeded.length === 0) {
          valid = false
          this.errors.rubriques = 'Vous devez choisir une rubrique.'
        }
        return valid
      },
      clearSelectedError(error) {
        this.errors[error] = ''
      },
      reducedFileName(name) {
        if (name.length > 53) {
          return name.substring(0, 50) + ' ...';
        } else {
          return name;
        }
      },
      checkRubriquePj() {
        if (this.validateRubriquePj()) {
          this.$refs['modal-rubrique-pj'].hide()
          this.initiateMailMutex()
        }
      },
      cancelMailMutex() {
        this.pjNeeded = []
        this.rubriquesNeeded = []
        this.mailAttachments = []
        this.$refs['modal-mail-to-mutex'].hide();
      },
      validateMailCaracteres() {
        return this.rubriquesNeeded.indexOf('[rubrique]') === -1;
      },
      validateMailMutex() {
        let valid = true;
        if (isEmpty(this.mutexTo)) {
          valid = false;
          this.errors.mutexTo = 'Vous devez entrer une adresse de destination.'
        }
        if (isEmpty(this.mutexSubject)) {
          valid = false;
          this.errors.mutexSubject = 'Vous devez spécifier l\'objet du mail.'
        }
        if (isEmpty(this.mutexBody) || this.mutexBody === this.signatureMail) {
          valid = false;
          this.errors.mutexBody = 'Vous devez saisir un message.'
        }
        return valid;
      },
      sendReponseMutex(type) {
        this.clearErrorsMail();
        if (this.validateMailMutex()) {
          this.sendMailMutex();
        }
      },
      async sendMailMutex() {
        if (this.validateMailCaracteres()) {
          // send mail to Mutex
          let self = this;
          let formData = new FormData();
          formData.append('mutexTo', this.mutexTo);
          formData.append('mutexCc', this.mutexCc);
          formData.append('mutexSubject', this.mutexSubject);
          formData.append('mutexBody', this.mutexBody);
          formData.append('rubrique', this.rubriquesNeeded);
          if (this.pjNeeded.length > 0) {
            this.pjNeeded = this.pjNeeded.filter(pj => pj.size < this.maxPjMutex)
          }
          formData.append('piecesJointes', JSON.stringify(this.pjNeeded));
          formData.append('dossierId', this.dossier.id);
          formData.append('mailMutexId', this.mailMutexId);
          formData.append('traitementId', this.$route.query.traitementId);

          if (this.pjNeeded.length > 0) {
            // On commence par enregistrer les éventuelles modifications dans la fiche dossier pour ne pas perdre les données lors du refresh du dossier
            await this.$parent.$parent.$parent.save('save');
            this.$store.commit('IS_LOADING', true);
            this.$axios
              .post('/espaceGestion/dossier/transmission-mutex', formData)
              .then(response => {
                this.$event.emit('refreshDossier');
                this.$store.commit('IS_LOADING', false);
                // this.mailAttachments = [];
                this.$refs['modal-mail-to-mutex'].hide();
                this.$swal({
                  position: "top",
                  type: "success",
                  title: "Succès !",
                  text: 'Mail correctement envoyé.',
                  showConfirmButton: false,
                  timer: 3000
                });
              })
              .catch(function (error) {
                // console.log(error);
                let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                if (error.response && error.response.status === 424) {
                  textError = error.response.data.message;
                }
                self.$refs['modal-mail-to-mutex'].hide();
                self.$store.commit('IS_LOADING', false);
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: textError,
                  showConfirmButton: false,
                  timer: 5000
                });
              });
          } else {
            this.$swal.fire({
              title: 'Êtes-vous sûr?',
              text: 'Voulez-vous vraiment envoyer le mail sans choisir des pièces jointes ?',
              type: 'warning',
              reverseButtons: true,
              showCancelButton: true,
              cancelButtonColor:"#ff1744",
              confirmButtonText: 'Annuler',
              cancelButtonText: 'Valider',
            }).then((result) => {
              if (result.value !== true) {
              // if (!isEmpty(result.dismiss) && result.dismiss === 'cancel') {
                // On commence par enregistrer les éventuelles modifications dans la fiche dossier pour ne pas perdre les données lors du refresh du dossier
                this.$parent.$parent.$parent.save('save');
                this.$store.commit('IS_LOADING', true);
                this.$axios
                  .post('/espaceGestion/dossier/transmission-mutex', formData)
                  .then(response => {
                    this.$event.emit('refreshDossier');
                    this.$store.commit('IS_LOADING', false);
                    // this.mailAttachments = [];
                    this.$refs['modal-mail-to-mutex'].hide();
                    this.$swal({
                      position: "top",
                      type: "success",
                      title: "Succès !",
                      text: 'Mail correctement envoyé.',
                      showConfirmButton: false,
                      timer: 3000
                    });
                  })
                  .catch(function (error) {
                    // console.log(error);
                    let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                    if (error.response && error.response.status === 424) {
                      textError = error.response.data.message;
                    }
                    self.$refs['modal-mail-to-mutex'].hide();
                    self.$store.commit('IS_LOADING', false);
                    self.$swal({
                      position: 'top',
                      type: 'error',
                      title: 'Attention !!',
                      text: textError,
                      showConfirmButton: false,
                      timer: 5000
                    });
                  });
                }
            })
          }
        } else {
          let textToReplace = 'Du texte à remplacer est encore présent. Il s\'agit du texte entre crochets par exemple "[rubrique] ou [XX / XX / XXXX]"';
          this.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: textToReplace,
              showConfirmButton: false,
              timer: 5000
          });
        }
      },
      showSentMailMutex() {
        this.$refs['modal-mails-mutex-envoye'].show();
      },
      canShowSentMailMutex() {
        let can = false;
        if (this.dossier.mail_mutex_envoye) {
          for (let mail of this.dossier.mail_mutex_envoye) {
            if (!isEmpty(mail.sent_at)) {
              can = true;
            }
          }
          return can;
        }
      },
      setMailMutexEnvoye() {
        let mailsMutexEnvoye = this.dossier.mail_mutex_envoye ? this.dossier.mail_mutex_envoye.filter(mail => !isEmpty(mail.sent_at)) : [];
        this.mailsMutex = mailsMutexEnvoye;
      },
      checkDate(type) {
        let currentTraitement = this.$parent.$parent.$parent.allTraitements.find(traitement => traitement.id === parseInt(this.$route.query.traitementId,10))
        if (this.getTypeDossier() === 'ij' || currentTraitement.libelle_technique === 'ij_gestion_prestation' || currentTraitement.libelle_technique === 'qualification_courrier') {
          if (type === 'debut') {
            if (this.myData.dateDebutSinistre < this.minDateDebutPsi) {
              this.$swal({
                position: 'top',
                type: 'warning',
                title: 'Attention !!',
                text: 'La date de début de période est en dehors des limites normalement autorisées (antériorité de plus de 5 ans). Assurez-vous d\'avoir saisie la bonne date.',
                showConfirmButton: false,
                timer: 0
              });
            }
          }
          if (type === 'fin') {
            let dateFin = new Date(this.myData.dateFinSinistre).getTime();
            let dateReception = new Date(this.dossier.date_reception).getTime();
            if (dateFin > dateReception) {
              this.$swal({
                position: 'top',
                type: 'warning',
                title: 'Attention !!',
                text: 'La date de fin de période est en dehors des limites normalement autorisées (postérieur à la date de réception). Assurez-vous d\'avoir saisie la bonne date.',
                showConfirmButton: false,
                timer: 0
              });
            }
          }
          if (type === 'repriseTempsComplet') {
            let dateFin = new Date(this.myData.dateFinSinistre).getTime();
            let dateRepriseTempsComplet = new Date(this.myData.dateRepriseTempsComplet).getTime();
            if (dateRepriseTempsComplet && dateRepriseTempsComplet < dateFin) {
              this.$swal({
                position: 'top',
                type: 'warning',
                title: 'Attention !!',
                text: 'La date de reprise à temps complet est en dehors des limites normalement autorisées (égale ou postérieur à la date de fin). Assurez-vous d\'avoir saisie la bonne date.',
                showConfirmButton: false,
                timer: 0
              });
            }
          }
        }
      },
      getRelancesItems() {
        let relances = [];
        if (!isEmpty(this.dossier.incidents)) {
          for (let incident of this.dossier.incidents) {
            if (incident.dpc && incident.sous_status_id === 17) {
              let typeDateRelance = this.getTypeDateRelance(incident.dpc);
              if (typeDateRelance.length > 0) {
                let destinataire = this.getDestinataireRelance(incident.dpc, typeDateRelance[0].date);
                relances.push({date_relance: typeDateRelance[0].date, type: typeDateRelance[0].type, destinataire: destinataire})
              }
            }
          }
        }
        this.relancesItems = relances;
      },
      getTypeDateRelance(dpc) {
        let res = []
        if (dpc.annual_reminder_at) {
          return [{date: dpc.annual_reminder_at, type: 'Relance annuelle'}];
        }else if (dpc.reminder3_at) {
          return [{date: dpc.reminder3_at, type: 'Relance 3'}];
        } else if (dpc.reminder2_at) {
          return [{date: dpc.reminder2_at, type: 'Relance 2'}];
        } else if (dpc.reminder1_at) {
          return [{date: dpc.reminder1_at, type: 'Relance 1'}];
        }
        return res;
      },
      getDestinataireRelance(dpc, date) {
        let dest = '';
        if (!isEmpty(dpc.dpc_mails)) {
          for (let mail of dpc.dpc_mails) {
            if (mail.sent_at === date) {
              dest = mail.to;
              break;
            }
          }
        }
        return dest;
      },
      canShowForward() {
        let currentCanal = this.allCanals.find(canal => canal.id === this.dossier.canal_id);
        let isCorrectCanal = currentCanal ? currentCanal.libelle_technique === 'ebf' : false;
        let hasDroit = hasRule(rules.FORWARD_RECEPTION_MAIL)

        return isCorrectCanal && hasDroit && this.dossier && isEmpty(this.dossier.mail_id);
      },
      getBalForward() {
        let self = this;
        this.$axios
          .get("/espaceGestion/mail/getbaltransfert")
          .then(response => {
            // console.log(response.data)
            for(let bal of response.data.balsTransfert) {
              this.balsTransfert[bal.id] = bal
            }

            this.balsForwardOption = response.data.balsTransfert.map( bal => {return {'value': bal.id, 'text': bal.libelle}})
            this.balsForwardOption.unshift({'value': null, 'text': 'Choisissez une BAL'})
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      forwardMail() {
        if (isEmpty(this.selectedBal)) {
          this.errors.selectedBal = 'Vous devez choisir une boîte où tranférer le mail';
        } else {
          let self = this;
          let dataPost = {
            dossier_id: this.dossier.id,
            bal_id: this.selectedBal,
            commentaire: this.commentaireForward
          }
          this.$axios
            .post("/espaceGestion/mail/forwardFromDossier", dataPost)
            .then(response => {
              this.$swal({
                position: "top",
                type: "success",
                title: "Succés !!",
                text: "Le mail a été correctement transféré",
                showConfirmButton: false,
                timer: 5000
              });
              this.selectedBal = null;
              this.commentaireForward = '';
              this.showForward = false;
            })
            .catch(function(error) {
              self.$store.commit("IS_LOADING", false);
              let text = "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI";

              if (error && error.response && error.response.status === 418) {
                text = error.response.data.message
              }
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: text,
                showConfirmButton: false,
                timer: 0
              });
            });
        }
      },
      cantEditFicheDC
    }
  }
</script>
<style scoped>
  .custom-input {
    display: inline-block !important;
    width:92%;
  }
  .custom-input-reduit {
    display: inline-block !important;
    width:80%;
  }
  .custom-checkbox {
    display: inline-block !important;
    margin-left: 5px;
  }

  .disabled-input {
    background-color: #c3e6f1 !important;
  }

</style>
<style type="text/css">
  .tooltip.b-tooltip.pre-formatted .tooltip-inner {
    white-space: pre-line;
    max-width: 100% !important;
  }

  .tooltip.b-tooltip.pre-formatted {
    max-width: 100%;
  }

  .ck.ck-editor {
    width: 100% !important;
  }

  .synthese-even {
    margin-left: 0;
    margin-right: 0;
    background-color: #fce6ec;
  }
  .synthese-odd {
    margin-left: 0;
    margin-right: 0;
    background-color: #fdf3f6;
  }
  .synthese-odd div:first-child, .synthese-even div:first-child {
    padding-left: 0;
  }
  .card-employeur-synthese {
    background-color: #fdf3f6;
  }

  #data-relances #card-body {
    padding: 9px
  }
  #data-relances {
    border-color: #f12d2d;
  }
</style>
